export const problemData = [{
        title: "卖家常见问题处理",
        className: "problem1",
        lastLevel: false,
        children: [{
                title: "未收到货",
                className: "problem2",
                lastLevel: false,
                children: [{
                        title: "首次来信",
                        className: "problem3",
                        lastLevel: true,
                        children: [{
                                title: "请求等待",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Glad to hear from you. Sorry for letting you wait so long.\nYour package has been sent out on 日期. \nAnd it usually takes around 15-25 business days for arrival because of the package shipped from China. But sometimes it may be delayed by many unsteady factors like customs, flights, weather, etc which are uncontrollable.\nSo could you please give us another some days? Your patience and understanding is so appreciated. \nAnd if the package still not arrives then, do remember to contact us again. We will surely give you a fast and satisfactory solution for you, you have my words. \nAny question or problem, do feel free to contact us. We will reply you within 24 hours.",
                                        footer: "\nBest regards,\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很高兴收到你的来信。很抱歉让您等了这么久。\n您的包裹已在日期发出。\n由于包裹是从中国运来，通常需要大约15-25个工作日到货。但有可能因为海关，航班，天气等不可控因素推迟。\n您是否能多给我们一点时间呢？ 非常感谢您的耐心等待和理解。\n如果包裹仍未到达，请记得再次与我们联系。我们向您承诺，一定会为您提供快速，满意的解决方案。\n如有任何问题或疑问，请随时与我们联系。我们会在24小时内回复您。",
                                        footer: "献上最好的祝福\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "请求等待一周",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your communication and letting us know the problem. We do appreciate it so much.\nFrom the message, we know you are very concerned about the package and we also totally understand the feeling. But international shipment is affected by many unsteady factors. Sometimes, the packages may be delayed a little.  \nAnd if you like, could you please give us another week? If the package still not arrived then, we’d like to give a refund or re-send for the transaction.\nAnd please let us know your idea for the solution of this problem. We sincerely believe we can solve the problem for you faster and more satisfactorily.\nLook forward to your reply ^_^\nAnd we sincerely believe nothing can be a problem with communication.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢您的沟通，让我们知道这个问题。对此我们非常感激。\n从消息中，我们了解到您非常关心包装，我们也完全理解这种感觉。但国际货运受到许多不稳定因素的影响。有时，包裹可能会延迟一点。\n如果您愿意，可以再给我们一个星期吗？ 如果包裹仍然没有到达，我们愿意退款或重新发货。\n请告诉我们您对此问题解决方案的想法。我们真诚地希望，我们能够更快，更令人满意地为您解决问题。\n期待您的回复^ _ ^\n我们真诚地相信，任何问题都可以通过沟通来解决。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "请求等待3天",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your communication and letting us know the problem. We do appreciate it so much.\nFrom the message, we know you are very concerned about the package and we also totally understand the feeling. But international shipment is affected by many unsteady factors. The packages sometimes may be delayed a little.  \nAnd if you like, could you please give us 3 days? If the package still not arrived then, we’d like to give a refund or re-send for the transaction.\nAnd please let us know your idea for the solution of this problem. We sincerely believe we can solve the problem for you faster and more satisfactorily.\nLook forward to your reply ^_^\nAnd we sincerely believe nothing can be a problem with communication.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢您的沟通，让我们知道这个问题。对此我们非常感激。\n从消息中，我们了解到您非常关心包装，我们也完全理解这种感觉。但国际货运受到许多不稳定因素的影响。有时，包裹可能会延迟一点。\n如果您愿意，可以再给我们3天时间吗？ 如果包裹仍然没有到达，我们愿意退款或重新发货。\n请告诉我们您对此问题解决方案的想法。我们真诚地希望，我们能够更快，更令人满意地为您解决问题。\n期待您的回复^ _ ^\n我们真诚地相信，任何问题都可以通过沟通来解决。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "晚发货，请求等待假装海关扣押了一段时间",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Sorry to hear that you haven't received the package.\nAfter we got your message, we contacted the logistic company immediately.\nWe were told that your package was delayed because of customs inspection, and your package has arrived in your country.\nSo could you please give us a few days more? Your patience and understanding is so appreciated. \nAnd if the package still not arrives then, do remember to contact us again. We will surely give you a fast and satisfactory solution for you \nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很抱歉您没有收到包裹。\n收到您的消息后，我们立即联系了物流公司。\n我们被告知，由于海关检查，您的包裹延迟了，目前您的包裹已抵达您所在的国家/地区。\n那么您能再给我们几天吗？ 非常感谢您的耐心和理解。\n如果包裹仍未到达，请记得再次与我们联系。 我们一定会为您提供快速，满意的解决方案。\n如有任何问题或疑问，请随时与我们联系。我们很高兴为您服务。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "晚发货，假装建议重发",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Sorry for letting you wait so long.\nAs your question, after we check, I guess that the item was lost by post-workers.\nHow about we resend the order for you to show our regret? If you agree with re-send, any way, we are trying our best to arrive you the item, no matter what would we pay for.\nHonestly, beg your forgiveness.\nLook forward to your reply!\nAnd we sincerely believe nothing can be a problem with communication.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很抱歉让您等了这么久。\n对于您所提的问题，经过确认，我猜这个包裹可能是被物流员工弄丢了。\n对此我们深表歉意，为了表示弥补，我们可以重新发货。如果您同意重新发货的话，我们会尽最大努力将包裹重新送到您手上。\n在此请求您的谅解。\n期待你的回复！\n我们真诚地相信，任何问题都可以通过沟通来解决。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "部分未收到，请求等待（拆分订单，无货后寄包裹）",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Glad to hear from you.\nWe are so sorry to hear that part of item missing.\nPlease don't worry, after we check. You order was sent out separately.\nBecause of international shipment, sometimes it may be delayed by many unsteady factors like customs, flights, weather, etc which are uncontrollable.\nSo could you please give us another some days? Your patience and understanding is so appreciated. \nAny question or problem, do feel free to contact us. It’s our biggest pleasure to serve you, my dear friend.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很高兴收到你的来信。\n对于您的部分包裹遗失，我们深表抱歉。\n经过确认，您的订单是单独发出的。\n由于国际运输，有时可能会因海关，航班，天气等许多不可控因素延迟到达。\n那么您能再给我们一些时间吗？ 非常感谢您的耐心和理解。\n如有任何问题或疑问，请随时与我们联系。亲爱的朋友，我们很高兴为您服务。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "建议重发，未收到，丢包",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Sorry for letting you wait so long.\nAs your question, after we check, I guess that the item was lost by post-workers.\nHow about we resend the order for you to show our regret? It usually takes around 15-25 business days for arrival. Or you’d like a refund instead? If you agree with resend, could you please check your address for us? Thanks in advance. Your idea will always be respected.\nThanks for your patience and understanding again.\nLook forward to your reply!\nAnd we sincerely believe nothing can be a problem with communication.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很抱歉让您等了这么久。\n对于您所提的问题，经过确认，我猜这个包裹可能是被物流员工弄丢了。\n对此我们深表歉意，为了表示弥补，我们可以重新发货。如果您同意重新发货的话，我们会尽最大努力将包裹重新送到您手上。\n在此请求您的谅解。\n期待你的回复！\n我们真诚地相信，任何问题都可以通过沟通来解决。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "丢包，建议有货重发，无货退款",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Sorry for letting you wait so long.\nAs your question, after we check, I guess that the item was lost by post-workers.\nSorry about the inconvenience that may cause.\nWe would like to send you to the item, but the SKU:  is unavailable. \nHow about we refund you the unavailable items and send the other items? What’s your idea? We will respect your idea.\nHonestly, beg your forgiveness. Thanks for your patience and understanding again.\nLook forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很抱歉让您等了这么久。\n对于您所提的问题，经过确认，我猜这个包裹可能是被物流员工弄丢了。\n很抱歉因此对您造成的不便。\n我们想给您重新发货，但SKU：目前无货。\n我们的建议是给您退还费用或者给您发货其他物品？对此您是否同意？我们会尊重您的意见。\n请求您的谅解。再次感谢您的耐心和理解。\n期待您的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "建议退款，丢包",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Sorry for letting you wait so long.\nAs your question, after we check, I guess that the item was lost by post-workers. \nWe would like to send you to the item, but the item is not available \nHow about we refund you the item to show our regret? What’s your idea? We will respect your idea.\nHonestly, beg your forgiveness. Thanks for your patience and understanding again.\nLook forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很抱歉让您等了这么久。\n对于您所提的问题，经过确认，我猜这个包裹可能是被物流员工弄丢了。\n我们想给您重新发货，但SKU：目前无货。\n对此我们深表歉意，为了表示弥补，我们的建议是给您退还费用？对此您是否同意？我们会尊重您的意见。\n请求您的谅解。再次感谢您的耐心和理解。\n期待您的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "部分未收到/发货错，建议重发",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your communication and letting us know the problem. We do appreciate it so much. \nAs your question, after we check, I guess it maybe the negligence of our packaging staff. \nHow about we re-send you the item to show our regret? What’s your idea? \nBy the way, as usual the item will take around 15-25 working days to reach your side.\nHonestly, beg your forgiveness.\nThanks for your patience and understanding again.\nWe will send out the item after get your kind reply.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢你的沟通，让我们知道这个问题。 对此我们非常感激。\n至于您提到的问题，我们检查后，我想这可能是我们的包装人员的疏忽。\n对此我们深表歉意，为了表示弥补，我们可重新发货。对此您有什么想法？\n顺便说一下，根据经验，该包裹需要大约15-25个工作日才能到达您的身边。\n请求您的谅解。\n再次感谢您的耐心和理解。\n我们会在收到您的回复后发出包裹。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "部分未收到/发错货，建议退款（无货）",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your communication and letting us know the problem. We do appreciate it so much. \nAs your question, after we check, I guess it maybe the negligence of our packaging staff.\nWe would like to send you to the item, but the item is not available \nHow about we refund you the item to show our regret? What’s your idea? We will respect your idea.\nHonestly, beg your forgiveness. Thanks for your patience and understanding again.\nLook forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢你的沟通，让我们知道这个问题。 对此我们非常感激。\n至于您提到的问题，我们检查后，我想这可能是我们的包装人员的疏忽。\n我们想给您重新发货，但该货物目前无货。\n对此我们深表歉意，为了表示弥补，我们可退还此费用。 对此您有什么想法？ 我们会尊重你的想法。\n请求您的谅解。 再次感谢您的耐心和理解。\n期待你的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "告知跟踪号（邮政）",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you for your purchase, I’m so sorry you waiting so long.\nThis is your tracking number 跟踪号, check website is http://www.17track.net/en/result/post.shtml. The package status is “状态”.\nAnd it usual takes 15-25 days to arrive you from shipping to deliver.\nSo could you please give us another some days? Your patience and understanding is so appreciated. \nAnd if the package still not arrives then, do remember to contact us again. We will surely give you a fast and satisfactory solution for you \nAny question or problem, do not hesitate to contact us. We will reply you within 24 hours.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "谢谢您的购买，很抱歉您等了这么久。\n这是您的物流单号，可以在网站上查看 http://www.17track.net/en/result/post.shtml。 包裹状态为“状态”。\n通常运输时间需要15-25天。\n所以，您是否可以再给我们几天时间？ 非常感谢您的耐心和理解。\n如果包裹仍未到达，请记得再次与我们联系。 我们一定会为您提供快速，满意的解决方案\n如有任何问题或疑问，请随时与我们联系。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "告知跟踪号（比邮）",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you for your purchase, I’m so sorry you waiting so long.\nThis is your tracking number 跟踪号, check website is http://www.bpostinternational.com/en/contact.. The package status is “状态”. By the way, we use the Belgian Post.\nAnd it usual takes 15-25 days to arrive you from shipping to deliver. \nSo could you please give us another some days? Your patience and understanding is so appreciated. \nAnd if the package still not arrives then, do remember to contact us again. We will surely give you a fast and satisfactory solution for you \nAny question or problem, do not hesitate to contact us. We will reply you within 24 hours.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "谢谢您的购买，很抱歉您等了这么久。\n这是您的物流单号，请查看网站是http://www.bpostinternational.com/en/contact ..包裹状态是“状态”。 顺便说一句，我们使用的是比利时邮政。\n通常运输时间需要15-25天。\n所以，您是否可以再给我们几天时间？ 非常感谢您的耐心和理解。\n如果包裹仍未到达，请记得再次与我们联系。 我们一定会为您提供快速，满意的解决方案\n如有任何问题或疑问，请随时与我们联系。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "客户询问跟踪号（没有跟踪号）",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Glad to hear from you. Thanks for your purchase.\nBecause the price is under £8.00/$8.00/€8.00, tracking numbers will be not update on the web, really sorry take inconvenient to you.\nBut please don’t worry, usually all our items can arrive safely in around 15-25 days because of international shipment. And of course sometimes it may be delayed a little due to many uncontrollable factors like customs, flights, etc.\nSo could you please give us another more days? \nAnd if the package still not arrives then, do remember to contact us again. \nGreetings from China here",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很高兴收到您的来信。 感谢您的购买。\n因为价格低于£8.00 / $ 8.00 /€8.00，跟踪号码不会在网上更新，真的很抱歉给您带来不便。\n但请不要担心，由于国际运输，我们的所有物品通常可在15-25天内安全抵达。 当然，由于许多无法控制的因素，如海关，航班等，有时可能会延迟一点。\n能请您再给我们几天时间吗？\n如果包裹仍未到达，请记得再次与我们联系。\n向您表达来自中国的问候",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "已签收，未到货（邮政）",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you for your purchase, I’m so sorry you waiting so long.\nWe shipped the item by USPS, this is your tracking number跟踪号, check website is   https://www.usps.com/.You can view it.\nhttp://www.17track.net/en/result/post.shtml. The package status is “状态”.\nAccording to the status, may be it arrived even delivered already, you can dial your local post office ask them send it to you or get it by yourself. Or the package in your postbox?\nIf you get the package or not, please feel free to contact us again.\nThanks for your patience again.\nAny request, contact us freely. We will reply you within 24 hours.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "谢谢您的购买，很抱歉您等了这么久。\n我们通过USPS发货，这是您的物流单号，网站是https://www.usps.com/。您可以上网站查询。\nhttp://www.17track.net/en/result/post.shtml。 包裹状态为“状态”。\n根据包裹状态，或许包裹已经到达甚至已经送达，您可以拨打当地邮局电话要求他们投递给您或自取。 或者包裹已经在您的信箱中？\n如果您收到包裹，请随时再与我们联系。\n再次感谢您的耐心等待。\n您有任何要求，请随时与我们联系。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "已签收，未收到/到达待取（挂号）",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you for your purchase, I’m so sorry you waiting so long.\nThis is your tracking number 跟踪号, check website is http://www.17track.net/en/result/post.shtml. You can view it.\nThe package status is “状态”.\nAccording to the status, may be it arrived even delivered already, you can dial your local post office ask them send it to you or get it by yourself. \nIf you get the package or not, please feel free to contact us again.\nThanks for your patience again.\nAny request, contact us freely. We will reply you within 24 hours.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "谢谢您的购买，很抱歉您等了这么久。\n这是您的物流单号，可以在网站上查看 http://www.17track.net/en/result/post.shtml。 您可以上网站查询。\n包裹状态为“状态”。\n根据包裹状态，或许包裹已经到达甚至已经送达，您可以拨打当地邮局电话要求他们投递给您或自取。\n如果您收到包裹，请随时再与我们联系。\n再次感谢您的耐心等待。\n您有任何要求，请随时与我们联系。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                        ],
                    },
                    {
                        title: "再次来信",
                        className: "problem3",
                        lastLevel: true,
                        children: [{
                                title: "建议重发",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your communication and patience shown in this transaction which we do appreciate so much.\nWe are sorry to know that the package still not arrived. Just as we’ve promised, we’d like solve the problem for you now. \nHow about arranging a re-send for this order? Or you’d like a refund instead? If you agree with resend, could you please check your address for us? Thanks in advance. Your idea will always be respected.\nWe will send out the item after get your kind reply.",
                                        footer: "\nBest regards,\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢您对于本次交易展现的沟通和耐心，我们非常感激。\n我们很遗憾地知道您的包裹还没有到达。 正如我们所承诺的那样，我们现在想为您解决问题。\n我们对此订单安排重新发货怎么样？ 或者您愿意接受退款？ 如果您同意重新发货，可以请您确认下地址吗？ 在此先对您表示感谢。 我们永远尊重您的想法。\n我们会在收到您的回复后发出包裹。",
                                        footer: "献上最好的祝福\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "建议退款",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your communication and patience shown in this transaction which we do appreciate so much.\nWe are sorry to know that the package still not arrives. Just as we’ve promised, we’d like to resolve the problem for you now.\nHow about we refund you the order? You can keep it as a gift when the package arrives later. How do you like this suggestion?\nLook forward to your reply!\nAnd we sincerely believe nothing can be a problem with communication.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢您对于本次交易展现的沟通和耐心，我们非常感激。\n很遗憾这个包裹还没有到货。 正如我们所承诺的那样，我们现在想为您解决问题。\n我们给您退款怎么样？ 当包裹到达后，您可以将其作为礼物保存。 你觉得这个建议怎么样？\n期待您的回复！\n我们真诚地相信，任何问题可以通过沟通解决。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "告知将要发",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thanks for your reply.\nWe will send it out for you within 24 hours. And it usually takes around 15-25 days for arrival. Sincerely hope the package can arrive ASAP ^_^\nAny question or problem, do feel free to contact us. It’s our biggest pleasure to serve you. We will reply you within 24 hours.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "感谢您的回复。\n我们会在24小时内给您发货。 通常需要15-25天左右到您身边。 真诚地希望包裹能够尽快到达^ _ ^\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "已重发有货的，退款无货的",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thanks for your kind reply. \nThe refund of unavailable item has been issued, please check your account.\nWe will send remaining item out for you within 24 hours. And it usually takes around 10-15 days for arrival. Sincerely hope the package can arrive ASAP ^_^\nAny question or problem, do feel free to contact us. It’s our biggest pleasure to serve you. We will reply you within 24 hours.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很抱歉您没有收到包裹。\n收到您的消息后，我们立即联系了物流公司。\n我们被告知，由于海关检查，您的包裹延迟了，目前您的包裹已抵达您所在的国家/地区。\n那么您能再给我们几天吗？ 非常感谢您的耐心和理解。\n如果包裹仍未到达，请记得再次与我们联系。 我们一定会为您提供快速，满意的解决方案。\n如有任何问题或疑问，请随时与我们联系。我们很高兴为您服务。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "已重发，请求等待",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We are sorry about that you have not received your first package.\nYour replacement has been resent on 发货时间. And it usually takes around 15-25 days for arrival. And if you like, could you please give us other days? Sincerely hope the package can arrive ASAP ^_^\nPlease give us a chance, and if the package still not arrives then, do remember to contact us again. We will give you a full refund. We don’t want to let you disappointed. Let customer satisfaction is our aim.\nAny question or problem, do feel free to contact us. It’s our biggest pleasure to serve you. ",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "我们很抱歉您没有收到第一个包裹。\n我们已经重新发货。 通常需要15-25天左右到您身边。 如果您愿意，可以请您多给我们一些时间吗？ 真诚地希望包裹能够尽快到达^ _ ^\n请给我们一个机会，如果包裹仍未到达，请记得再次与我们联系。 我们将全额退款。 我们不想让你失望。 让客户满意是我们的宗旨。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "告知已退款",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thanks for your kind reply.\nThe refund has been issued for you, please check it.\nThank you again for your patience and consideration shown in this transaction.\nIf the package happens to arrive you, please just keep it as a gift.\nAny question or problem, do not hesitate to contact us. We will reply you within 24 hours. ",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "感谢您的回复。\n退款已经发给您，请确认下。\n再次感谢您在本次交易中的耐心和理解。\n如果包裹刚好已经到您手上，请将其作为礼物保留。\n如有任何问题或疑问，请随时与我们联系。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "退款没收到，让客户询问Amazon",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Sorry to hear that you haven't received your refund.\nBut we indeed did a refund to you. Please see the attachment. \nWe have attach the picture to show refund status. \nThe refund only retreat to your account which you paid for this order. \nIf possible, maybe you could ask Amazon for a bright answer. \nThe refund should be returned to your account automatically.\nAny question or problem, do not hesitate to contact us. \nIt’s our biggest pleasure to serve you.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很抱歉听到您没有收到退款。\n但是，我们确实做了退款给您。 请参阅附件。\n我们附上图片以显示退款状态。\n退款仅退回到您为此订单支付的帐户。\n如果可能的话，也许您可以向亚马逊寻求准确的答案。\n退款应自动退回到您的帐户。\n如有任何问题或疑问，请随时与我们联系。\n我们很高兴为您服务。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "感谢买家答应等待",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thanks for your kind patience and big understanding, hope it will arrive you soon.\nAny question or problem, do feel free to contact us. We will reply you within 24 hours.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "感谢您的耐心和谅解，希望包裹能尽快到达。\n如有任何问题或疑问，请随时与我们联系。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "感谢买家的理解",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thanks for your big understanding. You are a very nice customer.\nAny question or problem, do feel free to contact us. We will reply you within 24 hours.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "感谢您的谅解。 你是一个非常好的客户。\n如有任何问题或疑问，请随时与我们联系。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "买家告知货收到，索要好评",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We are so happy to hear that you have received the item.\nThank you again for your big patience and understanding shown in this transaction. We do appreciate it so much.\nDo you like it? Your shopping experience is very important to us and our business. We would like to invite you to leave positive feedback on our products and service.\nThank you for your kindly help, and we look forward to providing you with the best buying experience again on Amazon!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "我们很高兴听到您收到了该物品。\n再次感谢您在此次交易中表现出的耐心和理解。 对此我们非常感激。\n你喜欢它吗？ 您的购物体验对我们和我们的业务非常重要。 我们想邀请您对我们的产品和服务给予积极的反馈。\n感谢您的帮助，我们期待在亚马逊上再次为您提供最佳购买体验！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "买家告知货收到",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We are so happy to hear that you have received the item.\nThank you again for your big patience and understanding shown in this transaction. We do appreciate it so much.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "我们很高兴听到您收到了该物品。\n再次感谢您在此次交易中表现出的耐心和理解。 对此我们非常感激。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "索要好评",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "It’s our biggest pleasure to serve you, my dear buyer.\nSatisfying every customer is our principle.\nHope you can give us a positive feedback for our service.\nGreetings from China here",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "亲爱的买家，我们非常高兴为您服务。\n满足每一位客户是我们的原则。\n希望您能为我们的服务提供积极的反馈。\n来自中国的问候",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                title: "物品破损",
                className: "problem2",
                lastLevel: false,
                children: [{
                        title: "首次来信",
                        className: "problem3",
                        lastLevel: true,
                        children: [{
                                title: "请求拍照-破损",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your communication and letting us know the problem. We do appreciate it so much.\nWe are so sorry to know that the item was damaged. Could you please take a photo of the damaged item? No hard feelings, it’s just our routine work and will also help us find out the exact reason for the damage in order to avoid the same problem again.\nThank you so much for your help and understanding.\nAnd we sincerely believe nothing can be a problem with communication.\nLook forward to your reply!",
                                        footer: "\nBest regards,\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢你的沟通，让我们知道这个问题。 对此我们非常感激。\n我们很遗憾地知道该物品已损坏。 你能拍一张受损物品的照片吗？ 没有其他的意思，这只是我们的日常工作，也将帮助我们找出损坏的确切原因，以便再次避免同样的问题。\n非常感谢你的帮助和理解。\n我们真诚地相信，任何问题都可以通过沟通解决。\n期待你的回复！",
                                        footer: "献上最好的祝福\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "建议重发-破损",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your communication and letting us know the problem. We do appreciate it so much. \nSorry about that the item was damaged.  \nBut please don’t worry; we’d like to fix the problem for you. \nHow about re-send you a perfect one to replace the damaged one? As to the damaged one, no need to send back. Certainly, we will pay for the postage.\nIt will be sent out after get your kind reply.\nLook forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢你的沟通，让我们知道这个问题。 对此我们非常感激。\n很抱歉该商品已损坏。\n但请不要担心; 我们想为您解决问题。\n我们重新发送一个好的商品来替换损坏的这一个怎么样？ 至于受损的这个，您无需退回。 当然，我们会支付邮费。\n它将在收到您的回复后发出。\n期待您的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "建议退款-破损",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your communication and letting us know the problem. We do appreciate it so much. \nSorry about that the item was damaged.  \nBut please don’t worry; we’d like to fix the problem for you. \nHow about refund you the damaged item? And you don’t need to return the damaged item to us.  Or what’s your idea?\nLook forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢你的沟通，让我们知道这个问题。 对此我们非常感激。\n很抱歉该商品已损坏。\n但请不要担心; 我们想为您解决问题。\n我们给您退款怎么样？ 而且您无需将损坏的物品退还给我们。 或者您有其他的意见吗？\n期待您的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "钻掉了或是什么掉了退部分款",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Sorry to hear that.\nBut don’t worry. We would like to resolve the problem for you now.\nHow about we refund you money to show our regret?\nWhat’s your idea? We will respect your idea always.\nWe are sorry for having you through this inconvenience.\nLooking forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很抱歉听到这个消息。\n但别担心。 我们现在想为您解决问题。\n为了表达歉意，我们可以给您退款。\n或者您有什么其他想法吗？ 我们将始终尊重您的想法。\n很抱歉让您感到不便。\n期待你的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                        ],
                    },
                    {
                        title: "再次来信",
                        className: "problem3",
                        lastLevel: true,
                        children: [{
                                title: "photo收到，建议重发",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "",
                                        footer: "\nBest regards,\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "我们看到了照片。 非常感谢你在这件事上的努力。\n正如我们承诺的那样，我们现在想为您解决问题。\n我们可以给您重新发货来替换损坏的商品。 至于受损的这个，您无需退回。 我们真的不想在退货时给您带来麻烦。\n我们还会更仔细地打包该商品以避免再次出现同样的问题。\n您觉得这个建议怎么样？\n期待您的回复！",
                                        footer: "献上最好的祝福\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "photo收到，建议退款",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We have received the photo you taken. Thank you so much for your effort in this matter.\nJust as we promised, we’d like to fix the problem for you now.\nHow about we do a refund for this matter? And you don’t need to return the item at your expense. How do you like this suggestion?\nOr what’s your idea? Your idea will be respected always.\nLook forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "我们已经收到您拍摄的照片。 非常感谢你在这件事上的努力。\n正如我们承诺的那样，我们现在想为您解决问题。\n我们给您退款怎么样？ 而且您无需自费退货。 您觉得这个建议怎么样？\n或者您有其他的意见吗？ 你的想法将永远受到尊重。\n期待您的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "photo未收到，询问",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thank you so much for your help. But we still have not received the photo that you sent to us. Could you please try again?\nThank you again for your help and consideration.\nLook forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "非常感谢你的帮助。 但我们仍未收到您发送给我们的照片。 能否请您再发送一次？\n再次感谢您的帮助和关注。\n期待您的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "告知24小时内重发",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thanks for your kind letter.\nWe will re-send the item for you in 24 hours. And we will also package it more carefully in order to avoid the same problem again.\nAnd it usually takes around 15-25 days for arrival. Hope the package can arrive ASAP. Thank you again for your understanding and communication shown in this transaction.\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "谢谢您的来信。\n我们将在24小时内为您重新发货。 我们还会更仔细地打包它，以便再次避免同样的问题。\n通常需要15-25天左右到您身边。 希望包裹能尽快到达。 再次感谢您在本次交易中的理解和沟通。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "告知已退款",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thanks for your kind reply.\nThe refund has been issued just as we agreed. Please check it.\nThank you again for your understanding and communication shown in this transaction.\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "感谢您的回复。\n退款已按我们协商的方式发出。 请确认一下。\n再次感谢您在本次交易中的理解和沟通。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "告知已退款",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Thanks for your kind reply.\nThe refund has been issued for you, please check it.\nThank you again for your patience and consideration shown in this transaction.\nIf the package happens to arrive you, please just keep it as a gift.\nAny question or problem, do not hesitate to contact us. We will reply you within 24 hours. ",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "感谢您的回复。\n退款已经发给您，请确认下。\n再次感谢您在本次交易中的耐心和理解。\n如果包裹刚好已经到您手上，请将其作为礼物保留。\n如有任何问题或疑问，请随时与我们联系。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                title: "描述不符",
                className: "problem2",
                lastLevel: false,
                children: [{
                        title: "首次来信",
                        className: "problem3",
                        lastLevel: true,
                        children: [{
                                title: "请求拍照-发错货时",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We are really sorry to hear that. And thank you so much for your communication for letting us know this problem.\nDid we send the wrong item to you? In order to find the best solution for this matter, could we trouble you to take a photo of the item you received?\nAnd we will surely give you a most satisfactory solution for you.\nLook forward to your reply!",
                                        footer: "\nBest regards,\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "听到这个消息我们真的很遗憾。 非常感谢您的沟通，让我们知道这个问题。\n我们发错了物品给你了吗？ 为了找到这个问题的最佳解决方案，可以麻烦您拍下收到的物品的照片？\n我们一定会为您提供最满意的解决方案。\n期待您的回复！",
                                        footer: "献上最好的祝福\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "建议重发-发错货时",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We are really sorry to hear that. And thank you so much for your communication for letting us know this problem.\nHow about re-sending you the right one for you? As to the original one, no need to send back. We really don’t want to trouble you.\nHow do you like this suggestion?\nLook forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "听到这个消息我们真的很遗憾。 非常感谢您的沟通，让我们知道这个问题。\n我们为您重新发送正确的产品怎么样？ 至于原来的那个，您不需要寄回。 我们真的不想麻烦您。\n您觉得这个建议怎么样？\n期待您的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "建议退款(部分退款，或全部)",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We are really sorry to hear that. And thank you so much for your communication for letting us know this problem.\nHow about we refund you refund amount for this matter? And you don’t need to return the item. How do you like this suggestion?\nOr what’s your idea? Your idea will be respected always.\nLook forward to your reply!\nAnd we sincerely believe nothing can be a problem with communication.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "听到这个消息我们真的很遗憾。 非常感谢您的沟通，让我们知道这个问题。\n我们给您退款怎么样？ 而且您不需要退货。 您觉得这个建议怎么样？\n或者您有其他的意见吗？ 你的想法将永远受到尊重。\n期待您的回复！\n我们真诚地相信，任何问题都可以通过沟通解决。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                        ],
                    },
                    {
                        title: "再次来信",
                        className: "problem3",
                        lastLevel: true,
                        children: [{
                                title: "告知会重发",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We will re-send the item for you in 24 hours.\nThank you again for your understanding and communication shown in this transaction.\nAnd it usually takes around 15-25 days for arrival. Hope the package can arrive ASAP.\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.",
                                        footer: "\nBest regards,\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "我们将在24小时内为您重新发货。\n再次感谢您在本次交易中的理解和沟通。\n通常需要15-25天左右到您身边。 希望包裹能尽快到达。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。",
                                        footer: "献上最好的祝福\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "告知已退款",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We have issued the refund just as we agreed, please check it.\nThank you again for your communication and kindness in this matter.\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "我们已根据我们的约定发出退款，请您确认下。\n再次感谢您在这件事上的沟通和理解。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                title: "订单问题",
                className: "problem2",
                lastLevel: false,
                children: [{
                        title: "取消交易",
                        className: "problem3",
                        lastLevel: true,
                        children: [{
                                title: "取消交易-付款前",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Because the payment is pending, so we could not operate it for you.  You can contact the Amazon.\nAny question or problem, do feel free to contact us. Thank you.",
                                        footer: "\nBest regards,\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "由于付款尚待处理，因此我们无法为您操作。 您可以联系亚马逊。\n如有任何问题或疑问，请随时与我们联系。 谢谢。",
                                        footer: "献上最好的祝福\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "客户取消交易-已付款，未寄出",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Your order has been canceled and the refund will be returned to your account automatically. Please check your account.\nAny question or problem, do feel free to contact us. Thank you.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "您的订单已取消，退款将自动退回到您的帐户。 请确认您的帐户。\n如有任何问题或疑问，请随时与我们联系。 谢谢。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "客户取消交易-已付款，已寄出",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We are sorry to hear that you’d like to cancel the order. And we’d like to, but the package has already sent out to you.\nIs it possible to continue the transaction? Since the package is already on its way to you? \nThank you so much for your understanding and consideration.\nLook forward to your reply!",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "我们很遗憾听到您要取消订单。 我们愿意取消，但包裹已经寄给您了。\n由于包装已经在送往您的路上了，是否有可能继续进行交易？ \n非常感谢您的理解和考虑。\n期待您的回复！",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "拒收",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Please refuse the package if the package happens to reach your side one day. Hope you could understand us. \nAnd when we get the package, we will refund you. Hope you could understand us.\nWe sincerely believe nothing can be a problem with communication.\nAny question or problem, do not hesitate to contact us. We will reply you within 24 hours.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "感谢您的回复。\n如果包裹到达您的身边，请拒收。 希望您能理解我们。\n当我们收到包裹时，我们会退还给您。 希望您能理解我们。\n我们真诚地相信，任何问题可以通过沟通解决。\n如有任何问题或疑问，请随时与我们联系。 我们会在24小时内回复您。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                        ],
                    },
                    {
                        title: "修改地址",
                        className: "problem3",
                        lastLevel: true,
                        children: [{
                                title: "可以修改",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Ok, no problem. We will ship the order to the new address. \nThanks for your support.",
                                        footer: "\nBest regards,\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "好的，没问题。 我们会将订单发送到新地址。",
                                        footer: "献上最好的祝福\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "修改地址-不能修改，货已发",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "We are sorry but your order has already been sent out to the original address shown on Amazon.\nMaybe you can ask someone there to receive the package for you first. OK?\nAny question or problem, do feel free to contact us. Thank you.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很抱歉，您的订单已经发送到亚马逊上显示的原始地址。\n也许你可以先请那里的人帮忙签收。 好不好？\n如有任何问题或疑问，请随时与我们联系。 谢谢。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "客户想某个时间到，到不了，问是否继续交易",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Glad to get your request.\nIt usual takes 15-25 days from ordered date to delivered date.\nBut, as you know, it is international shipment. But sometimes it may be delayed by many unsteady factors like customs, flights, weather, etc which are uncontrollable. So we could NOT make you a promise that the item could reach your side before sometime.\nThe parcel maybe will miss your delivery date. How about cancel this order for you? Or you want to continue the transaction? \nLook forward to your kind reply.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很高兴得到您的请求。\n下单到送达通常需要15-25天。\n但是，如您所知，这是国际货运。 但有时可能会被许多不稳定的因素推迟，例如海关，航班，天气等无法控制的因素。 所以我们不能向您承诺在某个时间之前该物品可以到达你的身边。\n包裹可能会比您的交货日期较晚到达。 您可以取消此订单？ 或者您想继续交易？\n期待您的回复。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "客户不回复，联系客户，问是否继续交易",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Glad to write you again.\nWe have replied you on time, but get no reply from you. Maybe you are so busy.\nThanks for your purchase.\nThe parcel maybe will miss your delivery date. How about cancel this order for you? Or you want to continue the transaction?\nLook forward to your kind reply.If you don't reply us within 48 hours, we will cancel the order for you to make my own decisions.\n",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很高兴再次给您写信。\n我们已经回复了您，但没有得到您的答复。 或许是因为您在忙。\n感谢您的惠顾。\n包裹可能会比您的交货日期较晚到达。 您可以取消此订单？ 或者您想继续交易？\n期待您的回复。如果您未在48小时内回复我们，我们将取消您的订单。\n",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                            {
                                title: "客户想某个时间到，不确定，请求等待",
                                className: "problem4",
                                content: {
                                    en: {
                                        header: "Dear Valued Customer, \n",
                                        mainContent: "Glad to get your request.\nYour package has been sent out on time\nIt usual takes 15-25 days from ordered date to delivered date.\nBut, as you know, it is international shipment. But sometimes it may be delayed by many unsteady factors like customs, flights, weather, etc which are uncontrollable. So we could NOT make you a promise that the item could reach your side before sometime.\nThanks for your patience.\nAny question, please contact us feel freely.",
                                        footer: "\nNice day.\nHelena",
                                    },
                                    zh: {
                                        header: "尊敬的客户，",
                                        mainContent: "很高兴得到您的请求。\n您的包裹已经发出。\n下单到送达通常需要15-25天。\n但是，如您所知，这是国际货运。 但有时可能会被许多不稳定的因素推迟，例如海关，航班，天气等无法控制的因素。 所以我们不能让你承诺在某个时间之前该物品可以到达你的身边。\n谢谢您的耐心等待。\n有任何疑问，请随时与我们联系。",
                                        footer: "祝您有美好的一天\n海伦娜",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                title: "退货问题",
                className: "problem2",
                lastLevel: true,
                children: [{
                        title: "不需要，要退回，问原因",
                        className: "problem3",
                        lastLevel: false,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Thanks for your purchase.\nWe are so sorry to hear that you would like return the item. Could you kind tell us why do you want to return it?\nDid you receive the package? Does the item was broken? Or we sent the wrong item to you? What is the matter with item?\nWe will surely give you a fast and satisfactory solution for you.\nLook forward to your reply ^_^\nAnd we sincerely believe nothing can be a problem with communication.",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "感谢您的惠顾。\n我们很遗憾听到您想要退回该物品。 你能告诉我们你为什么要退货吗？\n你收到包裹了吗？ 这件物品坏了吗？ 或者我们发错了物品给你？ 商品有什么问题？\n我们一定会为您提供快速，满意的解决方案。\n期待您的回复^ _ ^\n我们真诚地相信，任何问题都可以通过沟通解决。",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "发退回地址",
                        className: "problem3",
                        lastLevel: false,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "It's our return address:\n5th Floor Building 1，Jingang Road West 2011， Jin Yi new district，\nJinhua city, \nZhejiang Province，  \n321000, China\nPhone number: 13811951998\nPlease tell us tracking number when you return, we will refund to you. Thanks\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.\nLook forward to your reply",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "这是我们的回信地址：\n金义新区金港西路2011号1楼5楼\n金华市\n浙江省\n321000，中国\n电话号码：13811951998\n请在退货时告诉我们物流单号，我们会退款给您。 谢谢\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。\n期待你的回复",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "货物退回时（我方出运费）",
                        className: "problem3",
                        lastLevel: false,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "It's our return address:\n5th Floor Building 1，Jingang Road West 2011， Jin Yi new district，\nJinhua city, \nZhejiang Province，  \n321000, China\nPhone number: 13811951998\nPlease post the items by economic express. Certainly, we would like to pay for the freight. But please help us to pay for it first. Then, we will refund you all of the money ( +shipping cost) to you after we get the items. You have my words! \n \nIf we make a deal, please tell us.\nLooking forward to your reply",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "这是我们的回信地址：\n金义新区金港西路2011号1楼5楼\n金华市\n浙江省\n321000，中国\n电话号码：13811951998\n请用经济快递来寄送。 当然，我们愿意支付运费。 但请先帮我们付钱。 然后，我们将在收到物品后向您退还所有款项（+运费）。 我们向您保证！\n \n如果您同意此方案，请告知我们。\n期待您的回复",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "货物退回时（对方出运费）",
                        className: "problem3",
                        lastLevel: false,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "We are so sorry to hear that, we agree to return the items to us.\nBut you need pay for the freight cost because of there is no quality problem of goods.\nIt's our return address:\n5th Floor Building 1，Jingang Road West 2011， Jin Yi new district，\nJinhua city, \nZhejiang Province，  \n321000, China\nPlease tell us the tracking number when you return, and once we get the item and the item in a good condition we will refund to you. Thanks\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.\nLook forward to your reply",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "我们很遗憾听到这个消息，我们同意您将这些货物退还给我们。\n但是由于货物没有质量问题，您需要支付运费。\n这是我们的退货地址：\n金义新区金港西路2011号1楼5楼\n金华市\n浙江省\n321000，中国\n请在退货时告诉我们物流单号，一旦我们收到物品，我们将退款给您。 谢谢\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。\n期待您的回复",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "货物退回时（海外仓）",
                        className: "problem3",
                        lastLevel: false,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Though we don't know the reason why they are no longer required, we agree to return the items to us.\nBut you need pay for the freight cost, it's ruled by Amazon.\n \nIt's our return address:\nwang huan （107）\n970 E. 236th Street   \nCarson, CA   \n90745,\nUSA\n \nWhen we get the items, we will refund to you .thanks\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.\nLook forward to your reply!",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "虽然我们不知道您不再需要它们的原因，但我们同意您将这些物品退还给我们。\n但您需要支付运费，这是由亚马逊规定的。\n \n这是我们的退货地址：\n王欢（107）\n970 E. 236th Street\n卡森，加利福尼亚州\n90745，\n美国\n \n当我们收到物品时，我们会退还给您。谢谢\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。\n期待您的回复",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                ],
            },
            {
                title: "建议 UPS",
                className: "problem2",
                lastLevel: true,
                children: [{
                        title: "建议使用UPS的(美国站)",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Thanks for your inquiry.\nThere is a method to expedite the order; you can buy UPS on our store. It usual takes 5-7 days to arrive you. It will cost $30.00 extra. The ASIN is B00GV0KMG0, the link is http://www.amazon.com/gp/product/B00GV0KMG0\nYou buy or not buy please let us know \nLook forward to your kind reply.",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "感谢您的询问。\n有一种方法可以加速订单发货; 您可以在我们店购买UPS。 通常需要5-7天才能到达。 它将额外花费30美元。 ASIN是B00GV0KMG0，链接是http://www.amazon.com/gp/product/B00GV0KMG0\n您购买或不购买请告诉我们\n期待您的回复。",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "建议使用UPS的(英国站)",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Thanks for your inquiry.\nThere is a method to expedite the order; you can buy UPS on our store. It usual takes 5-7 days to arrive you. It will cost £18.00 extra. The ASIN is B00GV0MFJC, the link is http://www.amazon.co.uk/gp/product/B00GV0MFJC\nYou buy or not buy please let us know \nLook forward to your kind reply.",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "感谢您的询问。\n有一种方法可以加速订单发货; 您可以在我们店购买UPS。 通常需要5-7天才能到达。 它将额外支付18英镑。 ASIN是B00GV0MFJC，链接是http://www.amazon.co.uk/gp/product/B00GV0MFJC\n您购买或不购买请告诉我们\n期待您的回复。",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "UPS无法投递 让客户联系当地邮局",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Thanks for your purchase.\nYour package has been arrived your local post office. But they could not send it to you because of customs liquidation.\nPlease don't worry about that. You could call the local post office. We use the UPS.  This is your tracking number 1Z86285V6745023126. Check website is, http://wwwapps.ups.com/WebTracking/track. And they telephone number is 18007425877.\nHope you could get your package ASAP. ^-^\nLook forward to your reply!",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "感谢您的惠顾。\n您的包裹已抵达当地邮局。 但由于海关清算，他们无法送达给您。\n请不要担心。 你可以打电话给当地的邮局。 我们使用UPS。 这是您的单号1Z86285V6745023126。 确认网站是，http：//wwwapps.ups.com/WebTracking/track。 他们的电话号码是18007425877。\n希望您尽快收到您的包裹。^ - ^\n期待您的回复！",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "UPS无法投递 联系不上客户，联系亚马逊",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Amazon seller support,",
                                mainContent: "Glad to write you.\nThe customer purchased items from our store.\nOur logistics company delivery parcel for many times, unable to deliver success. Because of the phone number is unusable, and they could not contact the customer.\nWe use the UPS. This is the tracking number 1ZA200980471535435. Check website is, http://wwwapps.ups.com/WebTracking/track. And the local post office telephone number is 496966405060.\nWe also email the customer many times, but got no reply from the customer. You could check our history emails.\nNow, the logistics company told us October 10 is the deadline, they would not delivery parcel. They will not delivery parcel. They said, either we bear the freight back from abroad, or give up the parcel.\nCould you help us how to solve the problem, can you contact the customer?\nLook forward to your reply.",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "亲爱的亚马逊卖家支持中心，",
                                mainContent: "很高兴写信给您。\n顾客从我们的商店购买物品。\n我们的物流公司多次交付包裹，无法交付成功。 由于电话号码无法使用，他们无法联系客户。\n我们使用UPS。 这是跟踪号1ZA200980471535435。 网址是，http：//wwwapps.ups.com/WebTracking/track。 当地邮局的电话号码是496966405060。\n我们也多次向客户发送电子邮件，但未得到客户的回复。 您可以查看我们的历史电子邮件。\n现在，物流公司告诉我们10月10日是最后期限，他们也不会送包裹。 他们不会交付包裹。 他们说，要么我们从国外承担运费，要么放弃包裹。\n您能帮我们解决问题吗，您能和客户联系吗？\n期待您的回复。",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                ],
            },
            {
                title: "缺货单，异常单联系",
                className: "problem2",
                lastLevel: true,
                children: [{
                        title: "假装包裹破损被退回，建议重发",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Glad to write you. Thanks for your purchase.\nBut we are so sorry to tell you that your package was returned because of the package was damaged.\nSorry about the inconvenience that may cause.\nHow about we resend the order for you?\nAnd please let us know your idea for the solution of this problem. We sincerely believe we can solve the problem for you faster and more satisfactorily.\nLook forward to your reply ^_^\nAnd we sincerely believe nothing can be a problem with communication.",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "很高兴写信给您。 感谢您的惠顾。\n但我们很遗憾地告诉您，由于包裹已损坏，您的包裹已退回。\n很抱歉给您造成的不便。\n我们给您重新发货怎么样？\n请告诉我们您解决此问题的想法。 我们真诚地相信，我们能够更快，更令人满意地为您解决问题。\n期待您的回复^ _ ^\n我们真诚地相信，任何问题都可以通过沟通解决。",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "假装包裹破损被退回，建议退款（无货）",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Glad to write you. Thanks for your purchase.\nBut we are so sorry to tell you that your package was returned because of the package was damaged.\nSorry about the inconvenience that may cause.\nWe would like to send you to the item, but the item is not available \nHow about we refund you the item to show our regret? What’s your idea? We will respect your idea.\nHonestly, beg your forgiveness. Thanks for your patience and understanding again.\nLook forward to your reply!",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "很高兴写信给您。 感谢您的惠顾。\n但我们很遗憾地告诉您，由于包裹已损坏，您的包裹已退回。\n很抱歉给您造成的不便。\n我们希望给您重新发货，但目前已经无货。\n为表示遗憾，我们可以给您退款怎么样？ 或者您有什么其他想法吗？ 我们会尊重你的想法。\n请求您的谅解。 再次感谢您的耐心和理解。\n期待您的回复！",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "假装包裹破损被退回，建议有货寄出无货退款 ",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Glad to write you. Thanks for your purchase.\nBut we are so sorry to tell you that your package was returned because of the package was damaged.\nSorry about the inconvenience that may cause.\nWe would like to send you to the item, but there has some items is unavailable. \nHow about we refund you the unavailable items and send the other items? What’s your idea? We will respect your idea.\nHonestly, beg your forgiveness. Thanks for your patience and understanding again.\nLook forward to your reply!",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "很高兴写信给您。 感谢您的惠顾。\n但我们很遗憾地告诉您，由于包裹已损坏，您的包裹已退回。\n很抱歉给您造成的不便。\n我们希望给您重新发货，但该商品目前已经无货。\n我们给您退款然后再给您发送另外的商品怎么样？ 或者您有什么其他想法吗？ 我们会尊重你的想法。\n请求您的谅解。 再次感谢您的耐心和理解。\n期待您的回复！",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "假装包裹破损被退回，建议自选（无货）",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Valued Customer,",
                                mainContent: "Sorry about the inconvenience that may cause.\nWe would like to send you to the item, but the item is not available.\nHow about choosing another item at a similar price from our store to be a replacement? Or you’d like a refund instead? Your idea will always be respected.\nHonestly, beg your forgiveness. Thanks for your patience and understanding again.\nLook forward to your reply!",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "很抱歉给您造成的不便。\n我们希望给您重新发货，但该商品目前无货。\n您从我们的商店选择另一件价格相近的商品作为替代品怎么样？ 或者你想要退款？ 你的想法永远受到尊重。\n请求您的谅解。 再次感谢您的耐心和理解。\n期待您的回复！",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                ],
            },
            {
                title: "运送及运费问题",
                className: "problem2",
                lastLevel: true,
                children: [{
                        title: "客户问可不可以统一运费",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Thank you so much for your attention for our items. We do appreciate it so much.\nOur shipping cost is part of commodity prices. So you will be paying delivery price for each item. Hope you could understand us.\nOnce again, we are really sorry for having you through this inconvenience. \nAny question or problem, do feel free to contact us.",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "非常感谢您对我们物品的关注。 对此我们非常感激。\n我们的运费是商品价格的一部分。 因此，您将支付每件商品的运费。 希望您能理解我们。\n再一次，我们真的很抱歉，给您带来不便。\n如有任何问题或疑问，请随时与我们联系。",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                    {
                        title: "运送问题-屏蔽国家解释",
                        className: "problem3",
                        lastLevel: true,
                        content: {
                            en: {
                                header: "Dear Valued Customer, \n",
                                mainContent: "Thank you so much for your attention for our items. We do appreciate it so much.\nWe are sorry, but due to shipping problems, right now we don’t ship items to your country.\nOnce again, we are really sorry for having you through this inconvenience. \nThank you again ^_^",
                                footer: "\nNice day.\nHelena",
                            },
                            zh: {
                                header: "尊敬的客户，",
                                mainContent: "非常感谢您对我们物品的关注。 对此我们非常感激。\n很抱歉，由于运输问题，我们现在不向您所在的国家/地区运送物品。\n再一次，我们真的很抱歉，给您带来不便。\n再次感谢你^ _ ^",
                                footer: "祝您有美好的一天\n海伦娜",
                            },
                        },
                    },
                ],
            },
            {
                title: "中差评Case问题",
                className: "problem2",
                lastLevel: false,
                children: [{
                        title: "Case",
                        className: "problem3",
                        lastLevel: false,
                        children: [{
                                title: "Item not received未收到货",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "建议重发-漏发(已回复)",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thanks for your purchase.\nWe are sorry to about that you missing an item in this order. \nIn fact, we have been replied you on Date. But we got no reply from you. Maybe you didn't notice it.\nPlease don't worry, we would like to solve the problem for you. \nHow about we resend the missing ring for you? Please let us know your idea. We will respect you. \nCould we trouble you to help us a favor? If possible, could you close the claim for us in advance? The claim is hurts our account so much. Thank you very much.\nWe are looking forward to your kindly reply.\nHave a good day.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "感谢您的惠顾。\n对于您未收到货，我们深表歉意。\n事实上，我们已经在日期回复了您。 但是我们没有收到您的回复。 也或许您没注意到它。\n请不要担心，我们想为您解决问题。\n我们为你重新发货丢失的戒指怎么样？ 请告诉我们您的想法。 我们会尊重你。\n我们可以请您帮一个忙吗？ 如果可能的话，您能否提前结束对我们的索赔？ 索赔会严重影响我们的帐号。 非常感谢您。\n我们期待着您的回复。\n祝你有美好的一天。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "建议重发-漏发(已回复)",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thanks for your purchase.\nWe are sorry to about that you missing an item in this order. \nIn fact, we have been replied you on Date. But we got no reply from you. Maybe you didn't notice it.\nPlease don't worry, we would like to solve the problem for you. \nHow about we resend the missing ring for you? Please let us know your idea. We will respect you. \nCould we trouble you to help us a favor? If possible, could you close the claim for us in advance? The claim is hurts our account so much. Thank you very much.\nWe are looking forward to your kindly reply.\nHave a good day.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "感谢您的惠顾。\n对于您未收到货，我们深表歉意。\n事实上，我们已经在日期回复了您。 但是我们没有收到您的回复。 也或许您没注意到它。\n请不要担心，我们想为您解决问题。\n我们为你重新发货丢失的戒指怎么样？ 请告诉我们您的想法。 我们会尊重你。\n我们可以请您帮一个忙吗？ 如果可能的话，您能否提前结束对我们的索赔？ 索赔会严重影响我们的帐号。 非常感谢您。\n我们期待着您的回复。\n祝你有美好的一天。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已重发，请求等待",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Glad to write you again. We are sorry about that you have not received your first package.\nYour replacement has been resent on Delivery time. And it usually takes around 15-20 days for arrival. And if you like, could you please give us other days? Sincerely hope the package can arrive ASAP ^_^\nPlease give us a chance, we promise you that if you still not get your item before OTD. We will give you a full refund. Please trust us, we don’t want to let you disappointed. Let customer satisfaction is our aim.\nAnd if possible, could we trouble you close the claim for us in advance? After all, as you know, we are just a new seller on Amazon, a good account is very important for us. Thank you so much in advance for your big help.\nAny question or problem, do feel free to contact us. It’s our biggest pleasure to serve you, my Dear Friend.",
                                                footer: "\nNice day.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很高兴再次给您写信。 我们很抱歉您没有收到第一个包裹。\n我们已经重新发货。 到达时通常需要15-20天左右。 如果您愿意，可以请您多给我们一些时间吗？ 真诚地希望包裹能够尽快到达^ _ ^\n请给我们一个机会，我们向您保证，如果您在到货时间之前仍未拿到您的物品。 我们将全额退款。 请相信我们，我们不想让您失望。 让客户满意是我们的宗旨。\n如果可能的话，我们可以请您提前撤回索赔吗？ 毕竟，如你所知，我们只是亚马逊上的新卖家，一个好的账户对我们来说非常重要。 非常感谢您的大力帮助。\n如有任何问题或疑问，请随时与我们联系。 亲爱的朋友，我们非常高兴为您服务。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "建议退款-漏发",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thanks for your purchase.\nWe are sorry to about that you missing an item in this order. \nPlease don't worry, we don’t want to let you disappointed. Let customer satisfaction is our aim.\nHow about we refund the missing item for you? Please let us know your idea. We will respect you. \nCould we trouble you to help us a favor? If possible, could you close the claim for us in advance? The claim is hurts our account so much. Thank you very much.\nWe are looking forward to your kindly reply.\nHave a good day.",
                                                footer: "\nNice day.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "感谢您的惠顾。\n对于您未收到货，我们深表歉意。\n请不要担心，我们不想让你失望。 让客户满意是我们的宗旨。\n我们为您退款怎么样？ 请告诉我们您的想法。 我们会尊重你。\n我们可以请您帮一个忙吗？ 如果可能的话，您能否提前结束对我们的索赔？ 索赔会严重影响我们的帐号。 非常感谢您。\n我们期待着您的回复。\n祝你有美好的一天。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "建议退款-丢包",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Glad to write you.\nWe are sorry to know that the package still not arrived. But please don’t worry, we’d like to resolve the problem for you now.\nHow about we refund you the order? You can keep it as a gift when the package arrived. How do you like this suggestion, my dear friend?\nAnd if possible, could we trouble you close the claim for us in advance? After all, as you know, we are just a new seller on Amazon, a good account is very important for us. Thank you so much for your big help.\nAnd then, we would give you the full refund for the order. Please trust us.\nLook forward to your reply.\nAnd we sincerely believe nothing can be a problem with communication.",
                                                footer: "\nNice day.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很高兴写信给您。\n很遗憾我们知道该商品尚未到货。 但请不要担心，我们现在想为您解决问题。\n我们退还订单怎么样？ 当包裹到达时，您可以将其作为礼物保存。 亲爱的朋友，你觉得这个建议怎么样？\n如果可能的话，我们可以请您提前撤回索赔吗？ 毕竟，如你所知，我们只是亚马逊上的新卖家，一个好的账户对我们来说非常重要。 非常感谢你的大力帮助。\n然后，我们会给您订单的全额退款。 请相信我们。\n期待您的回复。\n我们真诚地相信，任何问题都可以通过沟通解决。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "建议退款（建议重发无回复）",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Sorry to trouble you again. And hope everything is going well for you.\nMay be you didn't get our last E-mail, we knew that you were not so happy in this shopping.\nPlease don't worry, we don't want to let you disappointed. Let customer satisfaction is our aim.\nWe have suggested that we could re-send you the item, but got no reply from you. If you don't like us re-sending it, we would like to refund to you to show our sincerity. OK? What’s your idea?\nAnd if possible, could we trouble you close the claim for us in advance? After all, as you know, we are just a new seller on Amazon, a good account is very important for us. Thank you so much for your big help.\nAnd then, we would give you the full refund for the order. Please trust us.\nLook forward to your reply.\nAnd we sincerely believe nothing can be a problem with communication.",
                                                footer: "\nNice day.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "抱歉再次麻烦您。 希望您一切顺利。\n可能是您没有收到我们的最后一封电子邮件，我们知道你在交易时并不是那么愉快。\n请不要担心，我们不想让您失望。 让客户满意是我们的宗旨。\n我们建议我们可以重新向您重新发货，但未得到您的回复。 如果您不喜欢我们重新发货，我们会向您退款以表达我们的诚意。 好不好？ 或者您有什么其他想法吗？\n如果可能的话，我们可以请您提前撤回索赔吗？ 毕竟，如你所知，我们只是亚马逊上的新卖家，一个好的账户对我们来说非常重要。 非常感谢你的大力帮助。\n然后，我们会给您订单的全额退款。 请相信我们。\n期待您的回复。\n我们真诚地相信，任何问题都可以通过沟通解决。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "We are so sorry about that you have not received the package. \nAs you know, international shipment has many unsteady factors like customs, flights, weather, etc which are uncontrollable. Hope you could understand us.\nWe have issued the refund just as we agreed, please check your account.\nAnd if possible, could we trouble you close the claim for us in advance? After all, as you know, we are just a new seller on Amazon, a good account is very important for us. Thank you so much for your big help.\nLook forward to your reply.\nAnd we sincerely believe nothing can be a problem with communication.",
                                                footer: "\nNice day.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "我们很抱歉您没有收到包裹。\n如你所知，国际货运有许多不稳定的因素，如海关，航班，天气等，这是无法控制的。 希望您能理解我们。\n我们已根据我们的约定发出退款，请确认下您的帐户。\n如果可能的话，我们可以请您提前撤回索赔吗？ 毕竟，如你所知，我们只是亚马逊上的新卖家，一个好的账户对我们来说非常重要。 非常感谢你的大力帮助。\n期待您的回复。\n我们真诚地相信，任何问题都可以通过沟通解决。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                title: "Item not as described货物不符合描述",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "请求拍照-破损",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thank you so much for your communication and letting us know the problem. We do appreciate it so much.\nWe are so sorry to know that the item was damaged. Could you please take a photo of the damaged item? No hard feelings, it’s just our routine work and will also help us find out the exact reason for the damage in order to avoid the same problem again. And we will surely give you a most satisfactory solution for you.\nThank you so much for your help and understanding.\nAnd we sincerely believe nothing can be a problem with communication.\nCould we trouble you retract the claim for us? After all, as you know, we are just a new seller on Amazon, a good account is very important for us. Thank you so much in advance for your big help.\nWe are so sorry for any inconvenience this has caused you.\nAnd we sincerely believe nothing can be a problem with communication.\nLook forward to your reply!",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "非常感谢您的沟通，让我们知道这个问题。 对此我们非常感激。\n我们很遗憾地知道该物品已损坏。 你能拍一张受损物品的照片吗？ 没有其他的意思，这只是我们的日常工作，也将帮助我们找出损坏的确切原因，以便再次避免同样的问题。 我们一定会为您提供最满意的解决方案。\n非常感谢你的帮助和理解。\n我们真诚地相信，任何问题都可以通过沟通解决。\n我们可以麻烦您撤回对我们的索赔吗？ 毕竟，如你所知，我们只是亚马逊上的新卖家，一个好的账户对我们来说非常重要。 非常感谢您的大力帮助。\n对于给您带来的任何不便，我们深表歉意。\n我们真诚地相信，任何问题都可以通过沟通解决。\n期待您的回复！",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "建议重发-破损",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thanks for your purchase.\nWe are sorry to about that the item was broken. \nIn fact, we have been replied you on 29/09/2014 in the first time. But we got no reply from you. Maybe you didn't notice it.\nPlease don't worry, we don’t want to let you disappointed. Let customer satisfaction is our aim.\nHow about we resend you the broken item for you? Or you want to get a refund for the broken item? Please let us know your idea. We will respect you. \nAnd could we trouble you to help us a favor? If possible, could you close the claim for us in advance? The claim is hurts our account so much. Thank you very much.\nWe are looking forward to your kindly reply.\nHave a good day.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "感谢您的惠顾。\n我们很遗憾该商品已被破坏。\n事实上，我们第一次在29/09/2014回复了您。 但是我们没有收到您的回复。 也或许您没注意到它。\n请不要担心，我们不想让您失望。 让客户满意是我们的宗旨。\n我们为您重新发货怎么样？ 或者您想要获得破损物品的退款？ 请告诉我们您的想法。 我们会尊重您的意见。\n而我们能麻烦您帮我们一个忙吗？ 如果可能的话，您能否提前结束对我们的索赔？ 索赔会严重影响我们的帐号。 非常感谢您。\n我们期待着您的回复。\n祝你有美好的一天。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已重发-破损（有跟踪号）",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Glad to write you again. We are sorry to about that the item was broken. \nYour replacement has been resent on 07 Oct. This is the tracking number LN483962915CN, check website is   http://www.17track.net/en/result/post.shtml. You can view it. And it usually takes around 15-20 days for arrival. And if you like, could you please give us other days? Sincerely hope the package can arrive ASAP ^_^\nPlease give us a chance, we promise you that if you still not get your item before the end of this month. We will give you a full refund. Please trust us, we don’t want to let you disappointed. Let customer satisfaction is our aim.\nAnd if possible, could we trouble you close the claim for us in advance? After all, as you know, we are just a new seller on Amazon, a good account is very important for us. Thank you so much in advance for your big help.\nAny question or problem, do feel free to contact us. It’s our biggest pleasure to serve you, my Dear Friend.",
                                                footer: "\nNice day.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很高兴再次给您写信。我们很遗憾该商品已被破坏。\n您的换货已于10月7日重新发送。这是单号LN483962915CN，网站是http://www.17track.net/en/result/post.shtml。你可以查询它。到达时通常需要15-20天左右。如果你愿意，可以请你给我们多一些时间吗？真诚地希望包裹能够尽快到达^ _ ^\n请给我们一个机会，我们向您承诺，如果您在本月底之前仍未收到您的物品。我们将全额退款。请相信我们，我们不想让您失望。让客户满意是我们的宗旨。\n如果可能的话，我们可以请您提前撤回对我们的索赔吗？毕竟，如你所知，我们只是亚马逊上的新卖家，一个好的账户对我们来说非常重要。非常感谢您的大力帮助。\n如有任何问题或疑问，请随时与我们联系。亲爱的朋友，我们非常高兴为您服务。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "建议退款-破损（质量差）",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thanks for your purchase.\nWe are sorry to about that the item was broken. \nWe will tell the supplier to improve the quality of the items.\nIf possible, could you withdraw the claim for us in advance? \nWe are looking forward to your kindly reply.\nHave a good day.",
                                                footer: "\nNice day.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "感谢您的惠顾。\n我们很遗憾该商品已被破坏。\n我们会告诉供应商提高物品的质量。\n如果可能，您可以提前取消对我们的索赔吗？\n我们期待着您的回复。\n祝你有美好的一天。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                title: "Charge backs索赔回复",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "Charge backs问原因",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thanks for your purchase.\nWe are so sorry that you filed a chargeback to us. Could you kind tell us why?\nDid you receive the package? Does the item was broken? Or we sent the wrong item to you? What is the matter with item?\nWe will surely give you a fast and satisfactory solution for you.\nLook forward to your reply ^_^\nAnd we sincerely believe nothing can be a problem with communication.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "感谢您的惠顾。\n很抱歉，您向我们提出了退款申请。 您能告诉我们为什么吗？\n您收到包裹了吗？ 这件物品坏了吗？ 或者我们发错了货给您？ 商品有什么问题？\n我们一定会为您提供快速，满意的解决方案。\n期待您的回复^ _ ^\n我们真诚地相信，任何问题都可以通过沟通解决。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "未回复-已签收联系亚马逊",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from our store. \nThis is the tracking number 跟踪号, check website is   http://www.17track.net/en/result/post.shtml. You can view it.\nI check this package shipping detail, Status is delivered. You could check it.\nBecause of we don't want any customer disappointed. We contacted the customer many times to want to know why she files a chargeback to us, but get no reply from her.\nSo could we trouble you help us to retract the chargeback for us.\nThanks in advance.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持，",
                                                mainContent: "很高兴写信给您。\n客户从我们的商店购买了该商品。\n这是单号，查询网站是http://www.17track.net/en/result/post.shtml。 您可以查看它。\n我查看此包裹运输详情，状态已送达。 您可以确认一下。\n因为我们不希望任何客户失望。 我们多次与客户联系，想知道她为什么向我们提出退款，但没有得到她的答复。\n所以，我们可以麻烦你帮我们确认下回复吗。\n提前致谢。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        title: "Feedback反馈",
                        className: "problem3",
                        lastLevel: false,
                        children: [{
                                title: "未收到货",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "建议重发",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Sorry to hear that the package has not arrived you.\nPlease don't worry, we don’t want to let you disappointed. Let customer satisfaction is our aim.\nHow about we re-send you the order? It usual takes 15-25 days to arrive you. Certainly, we will pay for the postage. Or you want to get a refund right now? What’s your idea? We will respect your idea.\nAnd if it's possible, could we trouble you to revise the negative feedback .After all, as you know, we are just a new seller on Amazon, a feedback very important for us. Thank you so much in advance for your big help.\nHonestly, beg your forgiveness. Please, dear friend!\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很抱歉听到包裹还没到达。\n请不要担心，我们不想让您失望。 让客户满意是我们的宗旨。\n我们重新发货怎么样？ 通常需要15-25天才能到达。 当然，我们会支付邮费。 或者您想立即获得退款？ 或者您有什么其他想法吗？ 我们会尊重你的想法。\n如果有可能的话，我们是否可能会麻烦您修改负面反馈。毕竟，正如您所知，我们只是亚马逊的新卖家，这对我们来说非常重要。 非常感谢您的大力帮助。\n请求您的谅解。 拜托，亲爱的朋友！\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "告知将要重发",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thanks for your kindly reply. Honestly say sorry again.\nAs the agreement, we will re-send you the package within 24 hours. And it usually takes around 15-25 business days for arrival because of international shipment. \nWhen you received the package, please be sure to help us to remove the bad review\nAnd if it's possible, could we trouble you to revise the negative feedback in advance？ It does hurt our account a lot. After all, a good account is very important to us. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please!\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "谢谢你的回复。 再次向您表示抱歉。\n根据协议，我们将在24小时内将包裹重新发送给您。 由于国际运输，它通常需要大约15-25个工作日到货。\n当您收到包裹时，请一定要帮我们删除差评\n而且如果可能的话，我们可以麻烦您提前修改负面反馈？它会影响到我们的账号。 毕竟，一个好的账户对我们非常重要。 非常感谢您的大力帮助。\n请求您的谅解。 拜托了！\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已重发-有跟踪号",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Glad to write you again. How is everything going? \nWe are so sorry for any inconvenience this has caused you.\nYou replacement has been sent out on 5 Oct. This is your tracking number 跟踪号, check website is http://www.17track.net/en/result/post.shtml. You could view it. And it usually takes around 15-25 business days for arrival because of international shipment. \nAnd if it's possible, could we trouble you to revise the negative feedback？ It does hurt our account a lot. After all, a good account is very important to us. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please!\nLook forward to your reply.\n ",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很高兴再次给您写信。 最近怎么样？\n对于给您带来的任何不便，我们深表歉意。\n您的换货已于10月5日发出。这是您的跟踪单号，查询网站是http://www.17track.net/en/result/post.shtml。 你可以查看它。 由于国际运输，它通常需要大约15-25个工作日到货。\n而且如果可能的话，我们可以麻烦您修改下差评吗？这会严重影响到我们的账号。 毕竟，一个好的账户对我们非常重要。 非常感谢您的大力帮助。\n请求您的谅解。 拜托了！\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已重发-问有没有收到",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Glad to write you again. How is everything going? \nWe are so sorry for any inconvenience this has caused you.\nYou package was sent out on 16 Sep. It usually takes around 15-25 business days for arrival because of international shipment. Have you got your package? Would you like it?  If you have some dissatisfaction with our product or our service, could you kind tell us?\nAnd if it's possible, could we trouble you to revise the negative feedback？ It does hurt our account a lot. After all, a good account is very important to us. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please!\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很高兴再次给您写信。 最近怎么样？\n对于给您带来的任何不便，我们深表歉意。\n您的包裹已于9月16日发出。由于国际货运，通常需要15至25个工作日才能送达。 你有收到包裹吗？ 您会喜欢吗？ 如果您对我们的产品或我们的服务有些不满，您能告诉我们吗？\n而且如果可能的话，我们可以麻烦您修改下差评吗？这会严重影响到我们的账号。 毕竟，一个好的账户对我们非常重要。 非常感谢您的大力帮助。\n请求您的谅解。 拜托了！\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已重发-已签收",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: 'Glad to write you. How is everything going?\nAfter we check the replacement status is "Delivered". Would you get the item?\nDo you like the product? If you like them this time, could you revise the feedback for us?  It only takes a moment. After all, a good account is very important to us. If also unhappy, please tell us, we will fix the problem again and timely.\nThanks for your big help and your kind cooperation. Say sorry, if some inconvenience from us.\nWe are Look forward to your kind reply.',
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很高兴写信给您。 最近怎么样？\n我们确认后物流状态是“已到达”。 您收到货了吗？\n您喜欢这个产品吗？ 如果您喜欢的话，能否为我们修改反馈意见？ 它只需要一点时间。 毕竟，一个好的账户对我们非常重要。 如果还不满意，请告诉我们，我们会及时解决问题。\n感谢您的大力帮助和您的友好合作。 很抱歉给您造成的不便。\n我们期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "建议退款",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Sorry to hear that the package has not arrived you.\nPlease don't worry, we don’t want to let you disappointed. Let customer satisfaction is our aim.\nHow about we refund you 金额 to show our regret？If the package happens to arrive you, please just keep it as a gift.\nAnd please let us know your idea for the solution of this problem. We sincerely believe we can solve the problem for you faster and more satisfactorily.\nAnd if it's possible, could we trouble you to revise the negative feedback? It is similar to negative one and does hurt our account a lot. After all, a good account is very important to us. Thank you so much in advance for your big help.\nAnd we sincerely believe nothing can be a problem with communication.\nHonestly beg your forgiveness. Please!\nLook forward to your reply!",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很抱歉听到包裹还没到达。\n请不要担心，我们不想让您失望。 让客户满意是我们的宗旨。\n我们可以给您退款以表示遗憾？如果包裹已经收到的话，请将其作为礼物保留。\n请告诉我们您解决此问题的想法。 我们真诚地相信，我们能够更快，更令人满意地为您解决问题。\n如果可能的话，我们是否会让您麻烦修改负面反馈？ 它会严重影响我们的账号。 毕竟，一个好的账户对我们来说非常重要。 非常感谢您的大力帮助。\n我们真诚地相信，任何问题都可以通过沟通解决。\n请求您的谅解。 拜托了！\n期待您的回复！",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "We are so sorry about that you have not received the package. \nAs you know, international shipment has many unsteady factors like customs, flights, weather, etc which are uncontrollable. Hope you could understand us.\nWe have issued the refund just as we agreed, please check your account.\nAnd if it's possible, could we trouble you to revise the negative feedback .It is hurts our account so much. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please, my dear friend.\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "我们很抱歉您没有收到包裹。\n如你所知，国际货运有许多不稳定的因素，如海关，航班，天气等，这是无法控制的。 希望您能理解我们。\n我们已根据我们的约定发出退款，请确认下您的帐户。\n如果有可能的话，我们是否可以帮助您修改负面反馈。这会影响到我们的帐户。 非常感谢您的大力帮助。\n请求您的谅解。 拜托，亲爱的朋友。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已经全额退款，未收到回复，再次联系催促改差评",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "We are so sorry to trouble you again. And hope everything is going well.\nI'm really sorry about the item you purchase from our store wasn’t making you satisfied. It's certainly our fault, we will be careful about the package. \nWe have already refund to you please check it.\nAnd if it's possible, could we trouble you to remove the negative feedback .After all, as you know, we are just a new seller on Amazon, a feedback very important for us. Thank you so much in advance for your big help.\nHonestly, beg your forgive. Please!\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很抱歉再次麻烦您。 希望您一切顺利。\n我真的很抱歉您从我们的商店购买的商品并不能让您满意。 这当然是我们的错，我们以后会小心包装。\n我们已退款给您，请确认。\n而且如果可能的话，我们可以麻烦您删除差评吗。毕竟，您也知道，我们只是在亚马逊的新卖家，评价对我们非常重要。 非常感谢您的大力帮助。\n请求您的原谅。 拜托了！\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                title: "物品损坏",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "建议重发",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Sorry to hear that the item was damaged.\nPlease don't worry, we don’t want to let you disappointed. Let customer satisfaction is our aim.\nHow about re-send you a perfect one to replace the damaged one? As to the damaged one, no need to send back. We really don’t want to trouble you. Or you want to get a refund for the broken item? What’s your idea? We will respect your idea.\nAnd if it's possible, could we trouble you to revise the negative feedback? After all, as you know, we are just a new seller on Amazon, a feedback very important for us. Thank you so much in advance for your big help.\nHonestly, beg your forgiveness. Please, dear friend!\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很抱歉听到该物品已损坏。\n请不要担心，我们不想让您失望。 让客户满意是我们的宗旨。\n我们重新发送一个好的商品来替换损坏的这一个怎么样？ 至于受损的这个，您无需退回。 我们真的不想麻烦您。 或者您想要获得破损物品的退款？ 或者您有什么其他想法吗？ 我们会尊重你的想法。\n如果可以的话，我们可否请您修改差评？ 毕竟，如您所知，我们只是亚马逊上的新卖家，这对我们来说非常重要。 非常感谢您的大力帮助。\n请求您的谅解。 拜托，亲爱的朋友！\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已重发",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thanks for your kindly reply. Honestly say sorry again.\nAs the agreement, we will re-send you the replacement within 24 hours. And it usually takes around 15-25 business days for arrival because of international shipment. \nAnd if it's possible, could we trouble you to revise the negative feedback？ It does hurt our account a lot. After all, a good account is very important to us. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please!",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "谢谢您的回复。 再次向您表示抱歉。\n根据协议，我们将在24小时内重新向您发送更换件。 由于国际运输，它通常需要大约15-25个工作日到货。\n而且如果可能的话，我们可以麻烦您修改下差评吗？这会严重影响到我们的账号。 毕竟，一个好的账户对我们来说非常重要。 非常感谢您的大力帮助。\n请求您的谅解。 拜托了！",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已重发",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thanks for your kindly reply. Honestly say sorry again.\nAs the agreement, we will re-send you the replacement within 24 hours. And it usually takes around 15-25 business days for arrival because of international shipment. \nAnd if it's possible, could we trouble you to revise the negative feedback？ It does hurt our account a lot. After all, a good account is very important to us. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please!",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "谢谢您的回复。 再次向您表示抱歉。\n根据协议，我们将在24小时内重新向您发送更换件。 由于国际运输，它通常需要大约15-25个工作日到货。\n而且如果可能的话，我们可以麻烦您修改下差评吗？这会严重影响到我们的账号。 毕竟，一个好的账户对我们来说非常重要。 非常感谢您的大力帮助。\n请求您的谅解。 拜托了！",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "建议退款",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Sorry to hear that the item was damaged. We are so sorry for any inconvenience this has caused you. \nPlease don't worry, we don’t want to let you disappointed. Let customer satisfaction is our aim.\nHow about we refund you money to show our regret？And please let us know your idea for the solution of this problem. We sincerely believe we can solve the problem for you faster and more satisfactorily.\nAnd if it's possible, could we trouble you to revise the negative feedback? After all, as you know, we are just a new seller on Amazon, a feedback very important for us. Thank you so much in advance for your big help.\nHonestly, beg your forgiveness. Please, dear friend!\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很抱歉听到该物品已损坏。 对于给您带来的任何不便，我们深表歉意。\n请不要担心，我们不想让您失望。 让客户满意是我们的宗旨。\n我们可以给您退款以表示遗憾，怎么样？请告诉我们您解决此问题的想法。 我们真诚地相信，我们能够更快，更令人满意地为您解决问题。\n如果可以的话，我们可否请您修改差评？ 毕竟，如您所知，我们只是亚马逊上的新卖家，这对我们来说非常重要。 非常感谢您的大力帮助。\n请求您的谅解。 拜托，亲爱的朋友！\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "建议重发无收到回复，建议退款（请求客户改评时）",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Sorry to trouble you again. And hope everything is going well for you.\nMay be you didn't get our last E-mail, we knew that you were not so happy in this shopping through your feedback.\nPlease don't worry; we'd like to resolve the problem for you.\nWe have suggested that we could re-send you the item, but got no reply from you. If you don't like us re-sending it, we would like to refund to you to show our sincerity. OK? What’s your idea?\nPlease! Honestly beg your forgiveness. \nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you.\nWe are Look forward to your kindly reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "抱歉再次麻烦您。 希望您一切顺利。\n可能是您没有收到我们的最后一封电子邮件，通过您的反馈我们知道您在这次购物中并不是很高兴。\n请不要担心; 我们想为您解决问题。\n我们建议我们可以重新向您重新发货，但未得到您的回复。 如果您不喜欢我们重新发货，我们会向您退款以表达我们的诚意。 好不好？ 或者您有什么其他想法吗？\n拜托了！ 请求您的谅解。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务。\n我们期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "We are so sorry about that the item was damaged.\nAs you know, sometimes the post-workers treats the package was so rude. Hope you could understand us.\nWe have issued the refund just as we agreed, please check your account.\nAnd if it's possible, could we trouble you to revise the negative feedback .It is hurts our account so much. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please, my dear friend.\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "我们很抱歉该物品已损坏。\n如你所知，有时物流员工对待包裹比较粗暴。 希望您能理解我们。\n我们已根据我们的约定发出退款，请确认下您的帐户。\n如果有可能的话，我们是否可以帮助您修改负面反馈。这会影响到我们的帐户。 非常感谢您的大力帮助。\n请求您的谅解。 拜托，亲爱的朋友。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                title: "质量不满意",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "建议退款",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Sorry to know that the item could not make you satisfied.\nWe don’t want to let you disappointed. Let customer satisfaction is our aim.\nHow about we full refund you for this matter? As to the item, no need to send back. \nAnd please let us know your idea for the solution of this problem. \nWe sincerely believe we can solve the problem for you faster and more satisfactorily.\nAnd if it's possible, could we trouble you to revise the negative feedback? \nAs you know, we are just a new seller on Amazon, a feedback very important for us. \nThank you so much in advance for your big help.\nHonestly, beg your forgiveness. Please, dear friend!\nAny question or problem, do not hesitate to contact us. \nIt’s our biggest pleasure to serve you.\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很抱歉知道该商品无法让您满意。\n我们不想让您失望。 让客户满意是我们的宗旨。\n我们全额退款怎么样？ 至于货物您无需退回。\n请告诉我们您解决此问题的想法。\n我们真诚地相信，我们能够更快，更令人满意地为您解决问题。\n如果可以的话，我们可否请您修改差评？\n如您所知，我们只是亚马逊上的新卖家，这对我们来说非常重要。\n非常感谢您的大力帮助。\n请求您的谅解。 拜托，亲爱的朋友！\n如有任何问题或疑问，请随时与我们联系。\n我们很高兴为您服务。\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "We are so sorry for any inconvenience this has caused you. We will tell the supplier to improve the quality of the item. Please forgive us.\nWe have issued the refund just as we agreed, please check your account.\nAnd if it's possible, could we trouble you to revise the negative feedback .It is hurts our account so much. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please, my dear friend.\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "对于给您带来的任何不便，我们深表歉意。 我们会告诉供应商提高产品质量。 请原谅我们。\n我们已根据我们的约定发出退款，请确认下您的帐户。\n如果有可能的话，我们是否可以帮助您修改负面反馈。这会影响到我们的帐户。 非常感谢您的大力帮助。\n请求您的谅解。 拜托，亲爱的朋友。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                title: "尺寸不合适",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "部分退款",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thank you for shopping on our store.\nWe are so sorry to hear that the item was not fit for you. We have stated the size of item in the description. Hope you could understand us.\nPlease don't worry. We don't want to let you disappointed. Let customer satisfaction is our aim.\nHow about we refund you a half of amount as compensation? And you don’t need to return the item. How do you like this suggestion? What’s your idea? We will respect your idea.\nMaybe you could send it to your friend. Perhaps she might be like it and fit for her. \nAnd if it's possible, could we trouble you to revise the negative feedback .After all, as you know, we are just a new seller on Amazon, a feedback very important for us. Thank you so much in advance for your big help.\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "感谢您在我们的商店购物。\n我们很遗憾听到这个商品不适合你。 我们已在说明中说明了商品的大小。 希望您能理解我们。\n请不要担心。 我们不想让你失望。 让客户满意是我们的宗旨。\n我们退还一半的金额作为补偿怎么样？ 而且您不需要退货。 您觉得这个建议怎么样？ 或者您有什么其他想法吗？ 我们会尊重你的想法。\n也许您可以把它给您的朋友。 也许她可能会喜欢它并适合她。\n如果有可能的话，我们是否可以麻烦您修改差评。毕竟，正如您所知，我们只是亚马逊的新卖家，这对我们来说非常重要。 非常感谢您的大力帮助。\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "We are so sorry for any inconvenience this has caused you. \nWe have issued the refund just as we agreed, please check your account.\nAnd if it's possible, could we trouble you to revise the negative feedback .It is hurts our account so much. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please, my dear friend.\nAny question or problem, do not hesitate to contact us. It’s our biggest pleasure to serve you\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "对于给您带来的任何不便，我们深表歉意。\n我们已根据我们的约定发出退款，请确认下您的帐户。\n如果有可能的话，我们是否可以帮助您修改负面反馈。这会影响到我们的帐户。 非常感谢您的大力帮助。\n请求您的谅解。 拜托，亲爱的朋友。\n如有任何问题或疑问，请随时与我们联系。 我们很高兴为您服务\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                title: "其他原因",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "没有说明原因",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thank you for shopping on our store - we hope you are enjoying your purchase! \nWe are so sorry to get your negative feedback. Could you kind tell us why?\nWould you like the item? If you have some dissatisfaction with our product or our service, could you kind tell us?\nAnd if it's possible, could we trouble you to revise the negative feedback in advance? It is hurts our account a lot. Thank you so much in advance for your big help.\nAnd please let us know your idea for the solution. We sincerely believe we can solve the problem for you faster and more satisfactorily.\nHonestly beg your forgiveness. Please help.\nAnd we sincerely believe nothing can be a problem with communication.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "感谢您在我们的商店购物 - 我们希望您喜欢购买！\n我们很抱歉收到您的差评。 您能告诉我们为什么吗？\n您想要这个商品吗？ 如果您对我们的产品或我们的服务有些不满，您能告诉我们吗？\n而且如果可能的话，我们可以麻烦您帮忙修改差评吗？ 这会严重影响到我们的账号。 非常感谢您的大力帮助。\n请告诉我们您对该解决方案的想法。 我们真诚地相信，我们能够更快，更令人满意地为您解决问题。\n请求您的谅解。 请帮忙。\n我们真诚地相信，任何问题都可以通过沟通解决。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "因为运输慢中评",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Glad to write to you. How is everything going?\nHow about the item? Hope you love it.\nFrom the feedback, we know that you are not very happy with this purchase because of the express. After we get your feedback we improve our speed of express, thought as you know sometimes it may be delayed a little due to many uncontrollable factors like customs,flights,etc.\nAnd if it's possible, could we trouble you to revise the neutral feedback? It is similar to negative one and does hurt our account a lot. After all, a good account is very important to us. Thank you so much in advance for your big help.\nHonestly beg your forgiveness. Please help.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "很高兴写信给您。 最近怎么样？\n这个商品怎么样？ 希望您喜欢它。\n根据反馈，我们知道您因为快递的原因对此次购买不满意。 在我们得到您的反馈后，我们提高了快递的速度，希望您理解，由于许多无法控制的因素，如海关，航班等，有时可能会延迟一点。\n如果可能的话，我们是否可能会麻烦您修改中差评？ 它会严重影响我们的账号。 毕竟，一个好的账户对我们非常重要。 非常感谢您的大力帮助。\n请求您的谅解。 请帮忙。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "客户答应修改评价，告知步骤",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Valued Customer, \n",
                                                mainContent: "Thank you for your understanding again. As our agreement, we were pleased to get your help to revise the feedback. \nThe tangible Steps：\n1. Go to Amazon.com and click Your Account in the upper right hand corner.\n2. Click Your Orders.\n3. On the right, select a date range from the Date drop-down box. Click Go. \n   A list of orders appears.\n4. Locate your order and click View Order Details in the left-hand column, under the Order Placed date.\n5. Scroll down to Your Seller Feedback and click Remove. \n   The Remove Feedback page appears.\n6. Select a reason for removing the feedback, and then click Remove Feedback.\n \nHonestly, beg your favor. Thanks again.\nLook forward to your reply.",
                                                footer: "\nWarmest regards.\nHelena",
                                            },
                                            zh: {
                                                header: "尊敬的客户，",
                                                mainContent: "再次感谢您的理解。 根据我们的协议，我们很乐意帮助您修改反馈意见。\n具体步骤：\n1.转到Amazon.com，然后单击右上角的“您的帐户”。\n2.单击您的订单。\n3.在右侧，从“日期”下拉框中选择日期范围。 单击Go。\n    出现订单列表。\n4.找到您的订单，然后单击订单日期下左栏中的查看订单明细。\n5.向下滚动至“卖家反馈”，然后单击“删除”。\n    将显示“删除反馈”页面。\n6.选择删除反馈的原因，然后单击“删除反馈”。\n \n请求您的帮助。 再次感谢。\n期待您的回复。",
                                                footer: "祝您有美好的一天\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: "联系亚马逊",
                className: "problem2",
                lastLevel: false,
                children: [{
                        title: "Case",
                        className: "problem3",
                        lastLevel: false,
                        children: [{
                                title: "未收到",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "建议重发-丢包（无回复）",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you.\nWe got an email from our customer stating that she was never received the order. After we check, I guess it was lost by post workers. As you know, international shipment has many unsteady factors like customs, flights, weather, etc which are uncontrollable. Maybe the package was lost by post workers. Hope you could understand us. \nWe responded back to her and apologizing for her disappointment. We don’t want to let our customer disappointed. Let customer satisfaction is our aim. We stated that we would like to resend the item for her. But we still wait a reply from the customer. Maybe she didn't notice the email. Please see e-mails to and from the customer for reference.\nSo could we trouble you help us to close the claim for us in advance? No matter the customer wants resend or refund in the future, we will fulfill our responsibilities. Please trust us. \nThanks for your great help in advance.",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n我们收到了客户的电子邮件，说她未收到货。 经过我们确认之后，我猜它被邮政员工丢失了。 如您所知，国际货运有许多不稳定的因素，如海关，航班，天气等，这是无法控制的。 也许邮政工作人员弄丢了包裹。 希望您能理解我们。\n我们回复了她并为她的失望道歉。 我们不想让客户失望。 让客户满意是我们的宗旨。 我们说我们想为她重新发货。 但我们仍在等待客户的回复。 也许她没有注意到这封邮件。 请查看客户的往来电子邮件以供参考。\n那么我们可以请您提前关闭我们的索赔吗？ 无论客户希望将来重新发货或退款，我们都将履行我们的职责。 请相信我们。\n在此先感谢您的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款-丢包",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you.\nWe got an email from our customer stating that she was never received the order. After we check, I guess it was lost by post workers. As you know, international shipment has many unsteady factors like customs, flights, weather, etc which are uncontrollable. Maybe the package was lost by post workers. Hope you could understand us. \nWe don’t want to make you disappointed. So we did a full refund to the customer as compensation.\nCould we trouble you help us solve this problem and retract the claim for us? Thanks for your big help in advance. ",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n我们收到了客户的电子邮件，说她未收到货。 在我们检查之后，我猜它被邮政工人丢失了。 如你所知，国际货运有许多不稳定的因素，如海关，航班，天气等，这是无法控制的。 也许邮政工作人员丢失了包裹。 希望您能理解我们。\n我们不想让您失望。 因此，我们向客户全额退款作为补偿。\n我们能不能麻烦你帮我们解决这个问题，并撤回索赔？ 感谢您提前给予的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款-丢包（签收）",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: 'Glad to write you.\nWe got an email from our customer stating that she was not received the package. But after we check the status, the package has been delivered.\nThis is the tracking number 跟踪号, check website is http://www.17track.net/en/result/post.shtml. The status is "包裹状态."\nEven so, we still choose to believe the customer, we did a full refund to the customer. Let customer satisfaction is our aim, we don\'t want let our customer disappointed.\nSo could we trouble you help us to close the claim for us? \nThanks for your big help.',
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n我们收到了客户的电子邮件，说她没有收到包裹。 但在我们检查状态后，包裹已经送达。\n这是单号，查询网站是http://www.17track.net/en/result/post.shtml。 状态为“包裹状态”。\n即便如此，我们仍然选择相信客户，我们向客户全额退款。 让客户满意是我们的宗旨，我们不希望让客户失望。\n那么，我们可以帮助您解决对我们的索赔吗？\n谢谢你的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已重发-丢包",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you.\nWe got an email from our customer stating that she was never received the order. After we check, I guess it was lost by post workers. As you know, international shipment has many unsteady factors like customs, flights, weather, etc which are uncontrollable. Maybe the package was lost by post workers. Hope you could understand us. \nWe don’t want to let you disappointed. Let customer satisfaction is our aim. So we resend the package to our customer again. This is the tracking number 01049332860, check website is http://www.ppbyb.com/. And it usually takes around 15-20 days for arrival.\nSo could we trouble you help us to close the claim for us? \nThanks for your big help.",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n我们收到了客户的电子邮件，说她未收到货。 在我们检查之后，我猜它被邮政工人丢失了。 如你所知，国际货运有许多不稳定的因素，如海关，航班，天气等，这是无法控制的。 也许邮政工作人员丢失了包裹。 希望您能理解我们。\n我们不想让您失望。 让客户满意是我们的宗旨。 所以我们再次向我们的客户重新发送包裹。 这是跟踪号01049332860，查看网站是http://www.ppbyb.com/。 到达时通常需要15-20天左右。\n那么，我们可以请您帮忙解决对我们的索赔吗？\n谢谢你的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款-漏发",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you.\nWe got an email from our customer stating that she was missing a iterm from her order. After we check, I guess it maybe the negligence of our packaging staff. \nAfter our negotiation, we did a full refund of missing item to the customer as compensation.\nLet customer satisfaction is our aim, we don’t want to let you disappointed. \nCould we trouble you help us this problem and withdraw the claim for us? \nThanks for your big help in advance. ",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n我们收到了一封来自客户的电子邮件，声称她错未收到货。 在我们检查之后，我想这可能是我们包装人员的疏忽。\n经过我们的协商，我们将丢失物品全额退款给客户作为补偿。\n让客户满意是我们的宗旨，我们不想让您失望。\n我们可以请您帮忙解决这个问题并撤回对我们的索赔吗？\n感谢您提前给予的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                title: "描述不符",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "请求照片，未回复-破损",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from us. Unfortunately, we received an email from the customer stating that he was not satisfied with his order. We are so sorry about that. He said the items were damaged. We apologizing for his disappointment and we would like to solve the problem for him. We ask the customer for the photo to show the problem. However, we got not reply from the customer. We would like to solve the problem for our customer, but we don't have the evidence.\nCould we trouble you help us this problem and retract the claim for us? Thanks for your big help in advance. ",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给你。\n顾客从我们这里购买了商品。不幸的是，我们收到了客户发来的电子邮件，说他对他的订单不满意。我们对此很抱歉。他说这些东西都损坏了。我们为他的失望而道歉，我们想为他解决这个问题。我们要求顾客出示照片来说明问题。然而，我们没有收到顾客的回复。我们想为我们的客户解决这个问题，但我们没有证据。\n我们能麻烦你帮我们解决这个问题，收回我们的索赔吗？谢谢你的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款-破损",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from us. We got an email from the customer stating that the item was damaged. As you know, sometimes the post-workers treats the package was so rude. Hope you could understand us.\nLet customer satisfaction is our aim, we don’t want to let you disappointed. So we did a full refund to the customer as compensation.\nCould we trouble you help us this problem and retract the claim for us? Thanks for your big help in advance. ",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给你。\n顾客从我们这里购买了商品。我们收到了客户的电子邮件，说该物品被损坏了。正如你所知道的，有时候后工作人员对待这个包裹是如此的粗鲁。希望你能理解我们。\n让客户满意是我们的目标，我们不想让你失望。所以我们给顾客全额退款作为补偿。\n我们能麻烦你帮我们解决这个问题，收回我们的索赔吗？谢谢你的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "描述不符，让客户退回，但未退回",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from us. Unfortunately, we received an email from the customer stating that he was not satisfied with his order. He said the items were damaged. We are so sorry about that. We apologizing for his disappointment and we would like to solve the problem for him.\nWe ask the customer to return the wrong goods. Certainly, we would like to bear the postage. But we need the customer pay for it first, when we got the tracking number we will refund her postage.  However, the customer doesn't return it. \nCould we trouble you help us this problem and retract the claim for us in advance? Thanks for your big help in advance. Once we got the wrong item, we sincerely believe we can solve the problem for the customer faster and more satisfactorily. Please trust us.",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n客户从我们这里购买了该物品。 不幸的是，我们收到了客户的电子邮件，说他对订单不满意。 他说这些物品都被损坏了。 我们对此感到抱歉。 我们为他的失望道歉，我们想为他解决问题。\n我们要求客户退回错误的商品。 当然，我们愿意承担邮费。 但我们需要客户先垫付邮费，当我们得到单号时，我们将退还邮资。 但是，客户不愿意退货。\n我们可以请您帮忙解决这个问题，并提前撤回对我们的索赔吗？ 感谢您提前给予的大力帮助。 一旦我们收到货，我们真诚地相信我们可以更快，更令人满意地为客户解决问题。 请相信我们。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        title: "Feedback",
                        className: "problem3",
                        lastLevel: false,
                        children: [{
                                title: "未收到",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "已重发-已签收（原跟踪号已签收）",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from our store. We received an email from our customer stating that she was not received the package. But after we check the package, it was delivered. This is the tracking number 原跟踪号, check website is http://www.17track.net/en/result/post.shtml. You could check it. The package was delivered.\nWe choose to believe in customer. We don’t want to let you disappointed. Let customer satisfaction is our aim. So we resend the package to our customer again. This is the replacement tracking number 重发跟踪号, We check the package, the package also delivered. We contact the customer, but got no reply from her.\nCould we trouble you help us to remove the negative feedback for us? Thank you so much for your great help in advance.",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n客户从我们的商店购买了该商品。 我们收到了客户的电子邮件，说她没有收到包裹。 但在我们确认包裹状态后，它已经送达。 这是单号，查询网站是http://www.17track.net/en/result/post.shtml。 您可以确认一下。 包裹已交付。\n我们选择相信客户。 我们不想让您失望。 让客户满意是我们的宗旨。 所以我们再次向我们的客户重新发送包裹。 这是重发货的单号，我们确认包裹状态，包裹也送达了。 我们联系了客户，但未得到她的回复。\n我们能不能麻烦您帮忙删除差评？ 非常感谢你提前给予的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已重发-已签收（原订单丢包）",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from us. We got an email from our customer stating that she was not received the package. As you know, international shipment has many unsteady factors like customs, flights, weather, etc which are uncontrollable. Maybe the package was lost by post workers. Hope you could understand us.\nWe don't want any customer disappointed, so we resend the item to customer as compensation.\nThis is the tracking number 重发跟踪号, check website is http://www.17track.net/en/result/post.shtml. You can view it. I check this package shipping detail, Status is delivered. You could check it.\nAnd if possible, could we trouble you help us to remove the feedback?  It does hurt our account a lot. After all, a good account is very important to us. Thank you so much in advance for your big help.\nThanks in advance.",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n客户从我们这里购买了该物品。 我们收到了客户的电子邮件，说她没有收到包裹。 如你所知，国际货运有许多不稳定的因素，如海关，航班，天气等，这是无法控制的。 也许邮政工作人员丢失了包裹。 希望您能理解我们。\n我们不希望任何客户失望，因此我们将重新发货给客户作为补偿。\n这是单号，查询网站是http://www.17track.net/en/result/post.shtml。 您可以查看它。 我查看此包裹运输详情，状态已送达。 您可以确认一下。\n如果可能的话，我们可以请您帮忙删除差评吗？ 它会影响到我们的账号。 毕竟，一个好的账户对我们来说非常重要。 非常感谢您的大力帮助。\n提前致谢。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款-丢包",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from us. We got an email from our customer stating that she was not received the package. As you know, international shipment has many unsteady factors like customs, flights, weather, etc which are uncontrollable. Maybe the package was lost by post workers. Hope you could understand us.\nWe don’t want to let you disappointed. Let customer satisfaction is our aim. The refund has been issued, please check the order. However, the customer left a negative feedback.\nCould we trouble you help us to remove the negative feedback? It is really hurts our account. Thank you so much for your great help in advance.",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n客户从我们这里购买了该物品。 我们收到了客户的电子邮件，说她没有收到包裹。 如你所知，国际货运有许多不稳定的因素，如海关，航班，天气等，这是无法控制的。 也许邮政工作人员丢失了包裹。 希望您能理解我们。\n我们不想让您失望。 让客户满意是我们的宗旨。 退款已发出，请确认订单。 但是，客户留下了差评。\n我们能不能麻烦您帮我们删除中差评？ 这真的会影响我们的帐户。 非常感谢您提前给予的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "已退款-漏发",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from us. We got an email from our customer stating that she was missing an item from the package. We apologizing for her disappointment and stated that we will solve the problem for her.\nWe don’t want to let you disappointed. Let customer satisfaction is our aim. The refund of missing item has been issued, please check the order. However, the customer left a negative feedback.\nCould we trouble you help us to remove the negative feedback? It is really hurts our account. Thank you so much for your great help in advance.",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n客户从我们这里购买了该物品。 我们收到了一封来自客户的电子邮件，说她没收到包裹。 我们为她的失望道歉并表示我们将为她解决问题。\n我们不想让您失望。 让客户满意是我们的宗旨。 我们已退款，请确认订单。 但是，客户留下了差评。\n我们能不能麻烦您帮我们删除中差评？ 这真的会影响我们的帐户。 非常感谢您提前给予的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                title: "破损",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                    title: "已重发-已签收",
                                    className: "problem3",
                                    lastLevel: true,
                                    content: {
                                        en: {
                                            header: "Dear Amazon Seller Support, \n",
                                            mainContent: "Glad to write you. \nThe customer purchased the item from our store. We received an email from our customer stating that the item was broken. As you know, sometimes the post-workers treats the package was so rude. We responded back to her and apologizing for her disappointment, we would like to solve the problem for her.  So we resend the package to the customer to show our regrets.\nThis is replacement tracking number 跟踪号, check website is http://www.17track.net/en/result/post.shtml. You could check it. The package was delivered.\nWe ask the customer to remove the feedback, and she agrees. You could check our history message. However, the negative feedback still hasn’t removed.\nSo could we trouble you help us to remove the feedback?\nThanks in advance.",
                                            footer: "\nHave a nice day.\nHelena",
                                        },
                                        zh: {
                                            header: "亲爱的亚马逊卖家支持中心，",
                                            mainContent: "很高兴写信给您。\n客户从我们的商店购买了该商品。 我们收到了客户的电子邮件，说明该商品已损坏。 如你所知，有时物流员工对待包裹比较粗暴。 我们回复她并为她的失望道歉，我们想为她解决问题。 因此，我们将包裹重新发送给客户，以表示我们的遗憾。\n这是单号，查询网站是http://www.17track.net/en/result/post.shtml。 您可以确认一下。 包裹已送达。\n我们请求客户删除差评，她同意了。 您可以查看我们的历史信息。 但是，差评仍未消除。\n所以，我们可以麻烦你帮我们删除差评吗？\n提前致谢。",
                                            footer: "祝你今天愉快。\n海伦娜",
                                        },
                                    },
                                }, ],
                            },
                            {
                                title: "描述，期望",
                                className: "problem4",
                                lastLevel: true,
                                children: [{
                                        title: "已退款-客户同意删评",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from us. We got negative feedback from our customer stating that she was not satisfied with the item.\nWe don’t want to let you disappointed. Let customer satisfaction is our aim. So we did a full refund to our customer. You could check the order. We ask the customer to remove the feedback, and she agrees with us to remove it. But the negative feedback was still on the website. \nCould we trouble you help us to remove the feedback?\nThanks for your great help in advance.",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n客户从我们这里购买了该物品。 我们得到了客户的差评，表示她对该货品不满意。\n我们不想让您失望。 让客户满意是我们的宗旨。 因此，我们向客户全额退款。 你可以查看订单。 我们请求客户删除差评，她同意将其删除。 但差评仍在网站上。\n我们能不能麻烦你帮我们删除差评？\n在此先感谢您的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                    {
                                        title: "解释藏银",
                                        className: "problem3",
                                        lastLevel: true,
                                        content: {
                                            en: {
                                                header: "Dear Amazon Seller Support, \n",
                                                mainContent: "Glad to write you. \nThe customer purchased the item from our store. But our customer left a negative feedback that we thought it is unfair to us.\nTibetan silver is a name. In fact, it is an alloy, Tibetan silver is actually copper-nickel alloy It is not real silver, it isn't toxic. The Tibetan silver is not containing any dangerous things.  You could search it on the website. Hope you could understand us.\nAnd if possible, could we trouble you help us to remove this negative feedback? It really hurts our account a lot.\nThanks for your big help in advance.",
                                                footer: "\nHave a nice day.\nHelena",
                                            },
                                            zh: {
                                                header: "亲爱的亚马逊卖家支持中心，",
                                                mainContent: "很高兴写信给您。\n客户从我们的商店购买了该商品。 但我们的客户留下了差评，我们认为这对我们不公平。\n西藏银是一个名字。 事实上，它是一种合金，藏银实际上是铜镍合金，它不是真正的银，它是无毒的。 西藏银没有任何危险的东西。 你可以在网站上搜索它。 希望您能理解我们。\n如果可能的话，我们可以麻烦你帮我们删除差评吗？ 这真的会影响到我们的帐户。\n感谢您提前给予的大力帮助。",
                                                footer: "祝你今天愉快。\n海伦娜",
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        title: "买家常见问题模板",
        className: "problem1",
        lastLevel: false,
        children: [{
                title: "购买咨询",
                className: "problem2",
                lastLevel: false,
                children: [{
                        className: "problem3",
                        lastLevel: true,
                        title: "关于尺码",
                        children: [{
                                className: "problem4",
                                lastLevel: false,
                                title: "案列1",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello，seller , I wear US size 8 , could you give me some advice on which size I should buy from you?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，卖家，我穿8号美国码，你能给我一些关于我应该从你那里购买的尺码的建议吗？",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列2",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, what is the volt-ampere voltage of the smart charging plug sold in your store?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，请问你们商店里销售的智能充电插头，电压是多少伏安的？",
                                        footer: "",
                                    },
                                },
                            },
                        ],
                    },
                    {
                        className: "problem3",
                        lastLevel: true,
                        title: "关于运费",
                        children: [{
                            className: "problem4",
                            lastLevel: false,
                            title: "案列1",
                            content: {
                                en: {
                                    header: "",
                                    mainContent: "Hello , seller , can the shipping fee be paid together as I’ve bought several items from you?\n" +
                                        "Please. send me just in one package, thanks!",
                                    footer: "",
                                },
                                zh: {
                                    header: "",
                                    mainContent: "您好，卖家，我可以一起支付运费，因为我已经向您购买了几件商品吗？\n" +
                                        "请合并一个包裹发给我，谢谢！",
                                    footer: "",
                                },
                            },
                        }, ],
                    },
                    {
                        className: "problem3",
                        lastLevel: true,
                        title: "关税问题",
                        children: [{
                            className: "problem4",
                            lastLevel: false,
                            title: "案列1",
                            content: {
                                en: {
                                    header: "",
                                    mainContent: "Are there any import taxes or customs charges that I need to be aware of if I purchase this and have it shipped to Louisiana in the United States?",
                                    footer: "",
                                },
                                zh: {
                                    header: "",
                                    mainContent: "如果我购买此产品并将其运往美国路易斯安那州，是否需要注意进口税或海关费用？",
                                    footer: "",
                                },
                            },
                        }, ],
                    },
                    {
                        className: "problem3",
                        lastLevel: true,
                        title: "支付方式",
                        children: [{
                            className: "problem4",
                            lastLevel: false,
                            title: "案列1",
                            content: {
                                en: {
                                    header: "",
                                    mainContent: "Do you accept check or bank transfer? I do not have a PayPal account.",
                                    footer: "",
                                },
                                zh: {
                                    header: "",
                                    mainContent: "你接受支票或银行转账吗？ 我没有PayPal帐户。",
                                    footer: "",
                                },
                            },
                        }, ],
                    },
                    {
                        className: "problem3",
                        lastLevel: true,
                        title: "还价",
                        children: [{
                            className: "problem4",
                            lastLevel: false,
                            title: "案列1",
                            content: {
                                en: {
                                    header: "",
                                    mainContent: "Hello, I can give 100 dollars. Is it OK?",
                                    footer: "",
                                },
                                zh: {
                                    header: "",
                                    mainContent: "你好，我可以只付100美元。 可以吗？",
                                    footer: "",
                                },
                            },
                        }, ],
                    },
                ],
            },
            {
                title: "收货问题",
                className: "problem2",
                lastLevel: false,
                children: [{
                        className: "problem3",
                        lastLevel: true,
                        title: "未收到货",
                        children: [{
                                className: "problem4",
                                lastLevel: false,
                                title: "案列1",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, I have been buying goods for 14 days. How have I not received the goods?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我购买商品已经有14天了，怎么还没有收到货物？",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列2",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "followed your shipping message and still stayed in Shanghai for 4 days? why?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "我跟踪了你们的发货讯息，有4天的时间仍然还滞留在上海？为什么？",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列3",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "What logistics methods do you use to ship? According to the purchase agreement, I still have not received your goods?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你们是使用什么物流方式运送的？按照购买约定，我还是没有收到你们的货物？",
                                        footer: "",
                                    },
                                },
                            },
                        ],
                    },
                    {
                        className: "problem3",
                        lastLevel: true,
                        title: "发错货品",
                        children: [{
                                className: "problem4",
                                lastLevel: false,
                                title: "案列1",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, the goods I received are not the same as the ones we purchased. Please give me a reason.",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我收到的货物和我们购买的货物不一样，请给我一个理由。",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列2",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, I bought a 3XL code for a men's shirt. I received 2XL and can't wear it. What should I do?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我购买的是男士衬衫3XL码的，我收到的是2XL的，无法穿戴，怎么办？",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列3",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, the seller, the product I bought is a military green dress, I received a yellow dress, why?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，卖家，我购买的商品是军绿色的连衣裙，收到的是黄色的裙子，为什么？",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列4",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, the size of the handbag I bought is 60cm*36cm*4cm, I received 40cm*22cm*3cm, give me an explanation.",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我购买的手提包尺寸是60cm*36cm*4cm，我收到的是40cm*22cm*3cm，给我一个解释。",
                                        footer: "",
                                    },
                                },
                            },
                        ],
                    },
                    {
                        className: "problem3",
                        lastLevel: true,
                        title: "发漏货品",
                        children: [{
                                className: "problem4",
                                lastLevel: false,
                                title: "案列1",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, I bought 3 items together in your store, but I only received 2, why?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我在你们商店里一起买了3件商品，但我收到的只有2件，为什么？",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列2",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, the lady's windbreaker I bought is belted. I don't have a belt when I receive the goods. Why?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我购买的女士风衣是带有腰带的，收到货物没有腰带，为什么？",
                                        footer: "",
                                    },
                                },
                            },
                        ],
                    },
                    {
                        className: "problem3",
                        lastLevel: true,
                        title: "货物破损",
                        children: [{
                                className: "problem4",
                                lastLevel: false,
                                title: "案列1",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, I have received the purchased riding cup, which has been deformed by extrusion. What should I do?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我收到购买的骑行水杯，已经被挤压变形，怎样处理？",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列2",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, the down jacket I bought in your store, when the zipper is damaged, can not be used, how to deal with it?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我在你们商店里购买的羽绒服，收到时拉链损坏，无法使用，怎样处理？",
                                        footer: "",
                                    },
                                },
                            },
                        ],
                    },
                    {
                        className: "problem3",
                        lastLevel: true,
                        title: "订单问题",
                        children: [{
                                className: "problem4",
                                lastLevel: false,
                                title: "案列1",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, I bought a T-shirt in your store yesterday and paid for it, but we want to return the order, can we?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我昨天在你们商店里购买了一件T恤，已经付款，但我们想退掉订单，可以吗？",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列2",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, I bought the men's Martin boots, because of the quality is not satisfied, I want to return, can I?",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我购买的男士马丁靴，因质量不满意，我要退货，可以吗？",
                                        footer: "",
                                    },
                                },
                            },
                            {
                                className: "problem4",
                                lastLevel: false,
                                title: "案列3",
                                content: {
                                    en: {
                                        header: "",
                                        mainContent: "Hello, the earrings I received are very different from those shown in your store. I want to return the goods and ask for compensation.",
                                        footer: "",
                                    },
                                    zh: {
                                        header: "",
                                        mainContent: "你好，我收到的耳环，和你们商店里展示的差别很大，我要退货，并要求赔偿。",
                                        footer: "",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
export const buyerList = [{
        "userId": 1037427,
        "studentId": 1037026,
        "studentNo": "01130180236",
        "user": "3527258795",
        "real": "暨醉蝶",
        "count": 0,
        "questionList": []
    },
    {
        "userId": 1037428,
        "studentId": 1037027,
        "studentNo": "01130180237",
        "user": "4014546020",
        "real": "幸寄文",
        "count": 0
    },
    {
        "userId": 1037429,
        "studentId": 1037028,
        "studentNo": "01130180238",
        "user": "9313779760",
        "real": "赖白竹",
        "count": 0
    },
    {
        "userId": 1037430,
        "studentId": 1037029,
        "studentNo": "01130180239",
        "user": "9378501125",
        "real": "齐乐萱",
        "count": 0
    },
    {
        "userId": 1037431,
        "studentId": 1037030,
        "studentNo": "01130180240",
        "user": "2786618996",
        "real": "南雅旋",
        "count": 0
    },
    {
        "userId": 1037432,
        "studentId": 1037031,
        "studentNo": "01130180241",
        "user": "5839621767",
        "real": "鲁寒香",
        "count": 0
    }
]
export const issueList = [{
        "issue": "商品描述不准确",
        "messages": [
            "我购买的商品与描述中的颜色不一致，我预订的是灰色的，但收到的是黑色的。",
            "商品描述中提到了包含附件，但是实际收到的商品中并未包含附件。",
            "商品描述中没有提到的额外费用出现在了订单中，希望能够解决。",
            "描述中提到了商品具有某些特定功能，但实际上却没有。",
            "商品描述中的尺寸信息与实际情况不符合，导致我无法使用。",
            "商品描述中提到了包含保修，但实际上未提供保修信息。",
            "描述中的图片与实物存在明显差异，实际收到的商品质量低劣。",
            "描述中提到了商品是全新的，但实际上收到的商品有痕迹，似乎被使用过。",
            "商品描述中的重量信息与实际情况不符合，导致运费计算错误。",
            "商品描述中提到了具有特定品牌，但实际收到的商品没有品牌标识或是其他品牌的。",
            "商品描述中未提及的细节导致我对商品的理解与实际情况有偏差。"
        ]
    },
    {
        "issue": "商品质量问题",
        "messages": [
            "收到的商品有明显的质量问题，表面有刮痕，外观不符合预期。请提供退货和退款的方案。",
            "收到的商品存在严重的缺陷，导致无法正常使用，请尽快提供解决方案。",
            "商品的材质与描述中所述不符，质量低劣，希望提供退货或替换方案。",
            "商品在使用过程中出现了问题，如漏水、损坏等，希望提供售后服务。",
            "收到的商品存在安全隐患，可能存在质量问题，希望尽快处理。"
        ]
    },
    {
        "issue": "配送延迟或丢失",
        "messages": [
            "我的订单已经延迟了几天，但仍未收到。请帮我查看订单状态并提供更新。",
            "订单显示已送达，但我并没有收到包裹，可能丢失了，请帮忙解决。",
            "收到的包裹存在明显的损坏迹象，可能导致商品丢失，请尽快处理。",
            "订单延迟导致无法按时收到商品，希望提供解决方案或赔偿。",
            "包裹配送过程中出现了异常，导致无法及时送达，希望尽快解决。"
        ]
    },
    {
        "issue": "假冒品或盗版商品",
        "messages": [
            "我收到的商品质量低劣，怀疑是假冒品或盗版商品，请提供解决方案。",
            "商品上的品牌标识与官方网站的不符，可能是盗版商品，请尽快核实。",
            "收到的商品与正品有明显差异，可能是假冒品，请处理。",
            "商品包装上的标识与官方渠道不一致，可能是假冒品，请尽快核实。",
            "购买的商品与官方渠道提供的图片和描述不一致，怀疑是假冒品。"
        ]
    },
    {
        "issue": "退货和退款问题",
        "messages": [
            "我已经退货了，但还没有收到退款。请确认退款是否已处理，并提供相关信息。",
            "我需要退货，但不清楚退货流程，请提供详细的退货指南。",
            "退货流程太过复杂，希望提供更简便的解决方案。",
            "退货后退款迟迟未到账，希望尽快处理。",
            "退货时收到的退款金额与原订单金额不符，请核实并解决。"
        ]
    },
    {
        "issue": "客户服务体验",
        "messages": [
            "我尝试联系客服解决问题，但一直没有得到满意的答复。希望你们能提供更有效率的服务。",
            "之前的客服体验不佳，希望提供更专业、及时的客户服务。",
            "对之前的服务体验不满意，希望能得到更好的帮助。",
            "联系客服解决问题的过程中遇到了困难，请提供更多的支持和指导。",
            "客服解决问题的速度太慢了，希望提高效率。"
        ]
    },
    {
        "issue": "隐私和安全问题",
        "messages": [
            "在购物过程中我遇到了支付安全问题，希望你们能尽快解决。",
            "收到了涉及个人隐私的奇怪邮件，怀疑个人信息泄露，请尽快处理。",
            "订单支付过程中遇到了安全问题，请核实并解决。",
            "收到了未经授权的账户访问通知，怀疑账户存在安全问题，请尽快核实。",
            "个人信息泄露可能导致了其他安全问题，请尽快核实并处理。"
        ]
    },
    {
        "issue": "价格波动",
        "messages": [
            "我购买的商品价格在短时间内发生了较大波动，是否可以提供价格保护或补偿？",
            "购买的商品价格与之前相比有明显变化，请提供合理的解释。",
            "商品价格频繁波动，导致购买时机难以把握，请提供更稳定的价格政策。",
            "购买的商品价格在下单后突然上涨，是否可以调整价格以保持一致？",
            "商品价格波动导致购物体验不稳定，请提供更稳定的价格保障。"
        ]
    },
    {
        "issue": "售后支持问题",
        "messages": [
            "之前的售后服务未能解决我的问题，是否可以转接给更有经验的客服？",
            "售后支持不够及时，希望能够提供更快速的服务响应。",
            "联系客服解决问题的过程中遇到了困难，请提供更多的支持和指导。",
            "售后服务解决问题的速度太慢了，希望提高效率。",
            "对之前的售后支持体验不满意，希望提供更专业、及时的服务。"
        ]
    },
    {
        "issue": "商品包装问题",
        "messages": [
            "我收到的商品包装破损，可能导致商品受损，请提供退货或替换方案。",
            "商品包装质量差，导致商品在运输过程中受损，请提供解决方案。",
            "收到的商品包装损坏，希望提供更加完善的包装保护措施。",
            "商品包装不足以保护商品完好到达，导致商品受损，请提供解决方案。",
            "商品包装过于简陋，无法有效保护商品，希望提供更加完善的包装方案。"
        ]
    }
]